// @ts-nocheck
/* eslint-disable */
import { createElement, useMemo, type ComponentType, type JSX } from "react";
import { useTranslation, Trans, type TransProps } from "react-i18next";
type TypedTransProps<Value, Components> = Omit<TransProps<string>, "values" | "ns" | "i18nKey"> & ({} extends Value ? {} : {
    values: Value;
}) & {
    components: Components;
};
function createProxy(initValue: (key: string) => any) {
    function define(key: string) {
        const value = initValue(key);
        Object.defineProperty(container, key, { value, configurable: true });
        return value;
    }
    const container = {
        __proto__: new Proxy({ __proto__: null }, {
            get(_, key) {
                if (typeof key === "symbol")
                    return undefined;
                return define(key);
            }
        })
    };
    return new Proxy(container, {
        getPrototypeOf: () => null,
        setPrototypeOf: (_, v) => v === null,
        getOwnPropertyDescriptor: (_, key) => {
            if (typeof key === "symbol")
                return undefined;
            if (!(key in container))
                define(key);
            return Object.getOwnPropertyDescriptor(container, key);
        }
    });
}
export function useAFFiNEI18N(): {
    /**
      * `404 - Page Not Found`
      */
    ["404 - Page Not Found"](): string;
    /**
      * `Back to My Content`
      */
    ["404.back"](): string;
    /**
      * `Sorry, you do not have access or this content does not exist...`
      */
    ["404.hint"](): string;
    /**
      * `Sign in to another account`
      */
    ["404.signOut"](): string;
    /**
      * `AFFiNE Cloud`
      */
    ["AFFiNE Cloud"](): string;
    /**
      * `AFFiNE Community`
      */
    ["AFFiNE Community"](): string;
    /**
      * `About AFFiNE`
      */
    ["About AFFiNE"](): string;
    /**
      * `Access level`
      */
    ["Access level"](): string;
    /**
      * `Actions`
      */
    Actions(): string;
    /**
      * `Add Filter`
      */
    ["Add Filter"](): string;
    /**
      * `Add Workspace`
      */
    ["Add Workspace"](): string;
    /**
      * `Select the existed database file`
      */
    ["Add Workspace Hint"](): string;
    /**
      * `Add a sub doc inside`
      */
    ["Add a subpage inside"](): string;
    /**
      * `Add to Favourites`
      */
    ["Add to Favorites"](): string;
    /**
      * `Add to favourites`
      */
    ["Add to favorites"](): string;
    /**
      * `Added Successfully`
      */
    ["Added Successfully"](): string;
    /**
      * `Added to Favourites`
      */
    ["Added to Favorites"](): string;
    /**
      * `All changes are saved locally`
      */
    ["All changes are saved locally"](): string;
    /**
      * `All data has been stored in the cloud. `
      */
    ["All data has been stored in the cloud"](): string;
    /**
      * `All docs`
      */
    ["All pages"](): string;
    /**
      * `App Version`
      */
    ["App Version"](): string;
    /**
      * `Appearance Settings`
      */
    ["Appearance Settings"](): string;
    /**
      * `Append to Daily Note`
      */
    ["Append to Daily Note"](): string;
    /**
      * `Available Offline`
      */
    ["Available Offline"](): string;
    /**
      * `Back Home`
      */
    ["Back Home"](): string;
    /**
      * `Back to Quick Search`
      */
    ["Back to Quick Search"](): string;
    /**
      * `Back to all`
      */
    ["Back to all"](): string;
    /**
      * `Body text`
      */
    ["Body text"](): string;
    /**
      * `Bold`
      */
    Bold(): string;
    /**
      * `Cancel`
      */
    Cancel(): string;
    /**
      * `New avatar will be shown for everyone.`
      */
    ["Change avatar hint"](): string;
    /**
      * `New name will be shown for everyone.`
      */
    ["Change workspace name hint"](): string;
    /**
      * `View the AFFiNE Changelog.`
      */
    ["Changelog description"](): string;
    /**
      * `Check Keyboard Shortcuts quickly`
      */
    ["Check Keyboard Shortcuts quickly"](): string;
    /**
      * `Check Our Docs`
      */
    ["Check Our Docs"](): string;
    /**
      * `Check for updates`
      */
    ["Check for updates"](): string;
    /**
      * `Check for updates automatically`
      */
    ["Check for updates automatically"](): string;
    /**
      * `Choose your font style`
      */
    ["Choose your font style"](): string;
    /**
      * `Click to replace photo`
      */
    ["Click to replace photo"](): string;
    /**
      * `Client Border Style`
      */
    ["Client Border Style"](): string;
    /**
      * `Cloud Workspace`
      */
    ["Cloud Workspace"](): string;
    /**
      * `Code block`
      */
    ["Code block"](): string;
    /**
      * `Collaboration`
      */
    Collaboration(): string;
    /**
      * `Collaborating with other members requires AFFiNE Cloud service.`
      */
    ["Collaboration Description"](): string;
    /**
      * `Collapse sidebar`
      */
    ["Collapse sidebar"](): string;
    /**
      * `Collections`
      */
    Collections(): string;
    /**
      * `Communities`
      */
    Communities(): string;
    /**
      * `Confirm`
      */
    Confirm(): string;
    /**
      * `Connector`
      */
    Connector(): string;
    /**
      * `Contact us`
      */
    ["Contact Us"](): string;
    /**
      * `Contact Us`
      */
    ["Contact with us"](): string;
    /**
      * `Continue`
      */
    Continue(): string;
    /**
      * `Continue with Google`
      */
    ["Continue with Google"](): string;
    /**
      * `Convert to `
      */
    ["Convert to "](): string;
    /**
      * `Copied link to clipboard`
      */
    ["Copied link to clipboard"](): string;
    /**
      * `Copy`
      */
    Copy(): string;
    /**
      * `Copy Link`
      */
    ["Copy Link"](): string;
    /**
      * `Create`
      */
    Create(): string;
    /**
      * `Create or Import`
      */
    ["Create Or Import"](): string;
    /**
      * `Create a link you can easily share with anyone.`
      */
    ["Create Shared Link Description"](): string;
    /**
      * `Create a collection`
      */
    ["Create a collection"](): string;
    /**
      * `Create your own workspace`
      */
    ["Create your own workspace"](): string;
    /**
      * `Created`
      */
    Created(): string;
    /**
      * `Created Successfully`
      */
    ["Created Successfully"](): string;
    /**
      * `Created with`
      */
    ["Created with"](): string;
    /**
      * `Curve Connector`
      */
    ["Curve Connector"](): string;
    /**
      * `Customise`
      */
    Customize(): string;
    /**
      * `Customise your  AFFiNE Appearance`
      */
    ["Customize your  AFFiNE Appearance"](): string;
    /**
      * `Database file already loaded`
      */
    DB_FILE_ALREADY_LOADED(): string;
    /**
      * `Invalid Database file`
      */
    DB_FILE_INVALID(): string;
    /**
      * `Database file migration failed`
      */
    DB_FILE_MIGRATION_FAILED(): string;
    /**
      * `Database file path invalid`
      */
    DB_FILE_PATH_INVALID(): string;
    /**
      * `Data sync mode`
      */
    ["Data sync mode"](): string;
    /**
      * `Date`
      */
    Date(): string;
    /**
      * `Date Format`
      */
    ["Date Format"](): string;
    /**
      * `Default Location`
      */
    ["Default Location"](): string;
    /**
      * `By default will be saved to {{location}}`
      */
    ["Default db location hint"](options: {
        readonly location: string;
    }): string;
    /**
      * `Delete`
      */
    Delete(): string;
    /**
      * `Delete Member?`
      */
    ["Delete Member?"](): string;
    /**
      * `Delete Workspace`
      */
    ["Delete Workspace"](): string;
    /**
      * `After deleting this Workspace, you will permanently delete all of its content for everyone. No one will be able to recover the content of this Workspace.`
      */
    ["Delete Workspace Label Hint"](): string;
    /**
      * `Please type “Delete” to confirm`
      */
    ["Delete Workspace placeholder"](): string;
    /**
      * `Delete doc?`
      */
    ["Delete page?"](): string;
    /**
      * `Delete permanently`
      */
    ["Delete permanently"](): string;
    /**
      * `Disable`
      */
    Disable(): string;
    /**
      * `Disable Public Link`
      */
    ["Disable Public Link"](): string;
    /**
      * `Disable Public Link ?`
      */
    ["Disable Public Link ?"](): string;
    /**
      * `Disabling this public link will prevent anyone with the link from accessing this page.`
      */
    ["Disable Public Link Description"](): string;
    /**
      * `Disable Public Sharing`
      */
    ["Disable Public Sharing"](): string;
    /**
      * `Discover what's new`
      */
    ["Discover what's new"](): string;
    /**
      * `Discover what's new!`
      */
    ["Discover what's new!"](): string;
    /**
      * `Display Language`
      */
    ["Display Language"](): string;
    /**
      * `Divider`
      */
    Divider(): string;
    /**
      * `Download all data`
      */
    ["Download all data"](): string;
    /**
      * `Download core data`
      */
    ["Download core data"](): string;
    /**
      * `Download {{CoreOrAll}} data`
      */
    ["Download data"](options: {
        readonly CoreOrAll: string;
    }): string;
    /**
      * `It takes up more space on your device.`
      */
    ["Download data Description1"](): string;
    /**
      * `It takes up little space on your device.`
      */
    ["Download data Description2"](): string;
    /**
      * `Download updates automatically`
      */
    ["Download updates automatically"](): string;
    /**
      * `Early Access Stage`
      */
    ["Early Access Stage"](): string;
    /**
      * `Edgeless`
      */
    Edgeless(): string;
    /**
      * `Edit`
      */
    Edit(): string;
    /**
      * `Edit Filter`
      */
    ["Edit Filter"](): string;
    /**
      * `Editor Version`
      */
    ["Editor Version"](): string;
    /**
      * `Elbowed Connector`
      */
    ["Elbowed Connector"](): string;
    /**
      * `Enable`
      */
    Enable(): string;
    /**
      * `Enable AFFiNE Cloud`
      */
    ["Enable AFFiNE Cloud"](): string;
    /**
      * `If enabled, the data in this workspace will be backed up and synchronised via AFFiNE Cloud.`
      */
    ["Enable AFFiNE Cloud Description"](): string;
    /**
      * `The following functions rely on AFFiNE Cloud. All data is stored on the current device. You can enable AFFiNE Cloud for this workspace to keep data in sync with the cloud.`
      */
    ["Enable cloud hint"](): string;
    /**
      * `Enabled success`
      */
    ["Enabled success"](): string;
    /**
      * `Exclude from filter`
      */
    ["Exclude from filter"](): string;
    /**
      * `Expand sidebar`
      */
    ["Expand sidebar"](): string;
    /**
      * `Expand/Collapse Sidebar`
      */
    ["Expand/Collapse Sidebar"](): string;
    /**
      * `Export`
      */
    Export(): string;
    /**
      * `Export AFFiNE backup file`
      */
    ["Export AFFiNE backup file"](): string;
    /**
      * `You can export the entire Workspace data for backup, and the exported data can be re-imported.`
      */
    ["Export Description"](): string;
    /**
      * `Download a static copy of your page to share with others.`
      */
    ["Export Shared Pages Description"](): string;
    /**
      * `Export failed`
      */
    ["Export failed"](): string;
    /**
      * `Export success`
      */
    ["Export success"](): string;
    /**
      * `Export to HTML`
      */
    ["Export to HTML"](): string;
    /**
      * `Export to Markdown`
      */
    ["Export to Markdown"](): string;
    /**
      * `Export to PDF`
      */
    ["Export to PDF"](): string;
    /**
      * `Export to PNG`
      */
    ["Export to PNG"](): string;
    /**
      * `File already exists`
      */
    FILE_ALREADY_EXISTS(): string;
    /**
      * `Failed to publish workspace`
      */
    ["Failed to publish workspace"](): string;
    /**
      * `Favourite`
      */
    Favorite(): string;
    /**
      * `Favourite docs for easy access`
      */
    ["Favorite pages for easy access"](): string;
    /**
      * `Favourited`
      */
    Favorited(): string;
    /**
      * `Favourites`
      */
    Favorites(): string;
    /**
      * `Filters`
      */
    Filters(): string;
    /**
      * `Found 0 results`
      */
    ["Find 0 result"](): string;
    /**
      * `Found {{number}} result(s)`
      */
    ["Find results"](options: {
        readonly number: string;
    }): string;
    /**
      * `Font Style`
      */
    ["Font Style"](): string;
    /**
      * `Force Sign Out`
      */
    ["Force Sign Out"](): string;
    /**
      * `Full width Layout`
      */
    ["Full width Layout"](): string;
    /**
      * `General`
      */
    General(): string;
    /**
      * `Get in touch!`
      */
    ["Get in touch!"](): string;
    /**
      * `Get in touch! Join our communities.`
      */
    ["Get in touch! Join our communities"](): string;
    /**
      * `Get in touch! Join our communities.`
      */
    ["Get in touch! Join our communities."](): string;
    /**
      * `Go Back`
      */
    ["Go Back"](): string;
    /**
      * `Go Forward`
      */
    ["Go Forward"](): string;
    /**
      * `Got it`
      */
    ["Got it"](): string;
    /**
      * `Group`
      */
    Group(): string;
    /**
      * `Group as Database`
      */
    ["Group as Database"](): string;
    /**
      * `Hand`
      */
    Hand(): string;
    /**
      * `Heading {{number}}`
      */
    Heading(options: {
        readonly number: string;
    }): string;
    /**
      * `Help and Feedback`
      */
    ["Help and Feedback"](): string;
    /**
      * `How is AFFiNE Alpha different?`
      */
    ["How is AFFiNE Alpha different?"](): string;
    /**
      * `Image`
      */
    Image(): string;
    /**
      * `Import`
      */
    Import(): string;
    /**
      * `Increase indent`
      */
    ["Increase indent"](): string;
    /**
      * `Info`
      */
    Info(): string;
    /**
      * `Legal Info`
      */
    ["Info of legal"](): string;
    /**
      * `Inline code`
      */
    ["Inline code"](): string;
    /**
      * `Invitation sent`
      */
    ["Invitation sent"](): string;
    /**
      * `Invited members have been notified with email to join this Workspace.`
      */
    ["Invitation sent hint"](): string;
    /**
      * `Invite`
      */
    Invite(): string;
    /**
      * `Invite Members`
      */
    ["Invite Members"](): string;
    /**
      * `Invited members will collaborate with you in current Workspace`
      */
    ["Invite Members Message"](): string;
    /**
      * `Search mail (Gmail support only)`
      */
    ["Invite placeholder"](): string;
    /**
      * `It takes up little space on your device.`
      */
    ["It takes up little space on your device"](): string;
    /**
      * `It takes up little space on your device.`
      */
    ["It takes up little space on your device."](): string;
    /**
      * `It takes up more space on your device.`
      */
    ["It takes up more space on your device"](): string;
    /**
      * `It takes up more space on your device.`
      */
    ["It takes up more space on your device."](): string;
    /**
      * `Italic`
      */
    Italic(): string;
    /**
      * `Joined Workspace`
      */
    ["Joined Workspace"](): string;
    /**
      * `Jump to`
      */
    ["Jump to"](): string;
    /**
      * `Keyboard shortcuts`
      */
    ["Keyboard Shortcuts"](): string;
    /**
      * `Leave`
      */
    Leave(): string;
    /**
      * `Leave Workspace`
      */
    ["Leave Workspace"](): string;
    /**
      * `After you leave, you will no longer be able to access the contents of this workspace.`
      */
    ["Leave Workspace Description"](): string;
    /**
      * `After you leave, you will not be able to access content within this workspace.`
      */
    ["Leave Workspace hint"](): string;
    /**
      * `Hyperlink (with selected text)`
      */
    Link(): string;
    /**
      * `Loading...`
      */
    Loading(): string;
    /**
      * `Loading All Workspaces`
      */
    ["Loading All Workspaces"](): string;
    /**
      * `Local`
      */
    Local(): string;
    /**
      * `Local Workspace`
      */
    ["Local Workspace"](): string;
    /**
      * `All data is stored on the current device. You can enable AFFiNE Cloud for this workspace to keep data in sync with the cloud.`
      */
    ["Local Workspace Description"](): string;
    /**
      * `Markdown Syntax`
      */
    ["Markdown Syntax"](): string;
    /**
      * `Member`
      */
    Member(): string;
    /**
      * `{{name}} has been removed`
      */
    ["Member has been removed"](options: {
        readonly name: string;
    }): string;
    /**
      * `Members`
      */
    Members(): string;
    /**
      * `Manage members here, invite new member by email.`
      */
    ["Members hint"](): string;
    /**
      * `Move Down`
      */
    ["Move Down"](): string;
    /**
      * `Move Up`
      */
    ["Move Up"](): string;
    /**
      * `Move folder`
      */
    ["Move folder"](): string;
    /**
      * `Select a new storage location.`
      */
    ["Move folder hint"](): string;
    /**
      * `Move folder success`
      */
    ["Move folder success"](): string;
    /**
      * `Move doc to...`
      */
    ["Move page to"](): string;
    /**
      * `Move doc to...`
      */
    ["Move page to..."](): string;
    /**
      * `Move to`
      */
    ["Move to"](): string;
    /**
      * `Move to Trash`
      */
    ["Move to Trash"](): string;
    /**
      * `Moved to Trash`
      */
    ["Moved to Trash"](): string;
    /**
      * `My Workspaces`
      */
    ["My Workspaces"](): string;
    /**
      * `Name Your Workspace`
      */
    ["Name Your Workspace"](): string;
    /**
      * `Native Titlebar`
      */
    NativeTitleBar(): string;
    /**
      * `Navigation Path`
      */
    ["Navigation Path"](): string;
    /**
      * `New '{{query}}' doc`
      */
    ["New Keyword Page"](options: {
        readonly query: string;
    }): string;
    /**
      * `New Doc`
      */
    ["New Page"](): string;
    /**
      * `New Workspace`
      */
    ["New Workspace"](): string;
    /**
      * `New version is ready`
      */
    ["New version is ready"](): string;
    /**
      * `No item`
      */
    ["No item"](): string;
    /**
      * `Non-Gmail is not supported`
      */
    ["Non-Gmail"](): string;
    /**
      * `None yet`
      */
    ["None yet"](): string;
    /**
      * `Not now`
      */
    ["Not now"](): string;
    /**
      * `Note`
      */
    Note(): string;
    /**
      * `Official Website`
      */
    ["Official Website"](): string;
    /**
      * `Open Workspace Settings`
      */
    ["Open Workspace Settings"](): string;
    /**
      * `Open folder`
      */
    ["Open folder"](): string;
    /**
      * `Check the where the storage folder is located.`
      */
    ["Open folder hint"](): string;
    /**
      * `Open in new tab`
      */
    ["Open in new tab"](): string;
    /**
      * `Organise docs to build knowledge`
      */
    ["Organize pages to build knowledge"](): string;
    /**
      * `Owner`
      */
    Owner(): string;
    /**
      * `Page`
      */
    Page(): string;
    /**
      * `Paper`
      */
    Paper(): string;
    /**
      * `Pen`
      */
    Pen(): string;
    /**
      * `Pending`
      */
    Pending(): string;
    /**
      * `Permanently deleted`
      */
    ["Permanently deleted"](): string;
    /**
      * `Pivots`
      */
    Pivots(): string;
    /**
      * `Please type workspace name to confirm`
      */
    ["Placeholder of delete workspace"](): string;
    /**
      * `Please make sure you are online`
      */
    ["Please make sure you are online"](): string;
    /**
      * `Privacy`
      */
    Privacy(): string;
    /**
      * `Publish`
      */
    Publish(): string;
    /**
      * `Publish to web`
      */
    ["Publish to web"](): string;
    /**
      * ` The current workspace has been published to the web, everyone can view the contents of this workspace through the link.`
      */
    ["Published Description"](): string;
    /**
      * `Visitors can view the contents through the provided link.`
      */
    ["Published hint"](): string;
    /**
      * `Published to Web`
      */
    ["Published to Web"](): string;
    /**
      * `Publishing to web requires AFFiNE Cloud service.`
      */
    Publishing(): string;
    /**
      * `After publishing to the web, everyone can view the content of this workspace through the link.`
      */
    ["Publishing Description"](): string;
    /**
      * `Quick Search`
      */
    ["Quick Search"](): string;
    /**
      * `Quick search`
      */
    ["Quick search"](): string;
    /**
      * `Quick Search...`
      */
    ["Quick search placeholder"](): string;
    /**
      * `Search in {{workspace}}`
      */
    ["Quick search placeholder2"](options: {
        readonly workspace: string;
    }): string;
    /**
      * `Docs can be freely added/removed from pivots, remaining accessible from "All Docs".`
      */
    RFP(): string;
    /**
      * `Recent`
      */
    Recent(): string;
    /**
      * `Redo`
      */
    Redo(): string;
    /**
      * `Reduce indent`
      */
    ["Reduce indent"](): string;
    /**
      * `Remove from Pivots`
      */
    ["Remove from Pivots"](): string;
    /**
      * `Remove from favourites`
      */
    ["Remove from favorites"](): string;
    /**
      * `Remove from workspace`
      */
    ["Remove from workspace"](): string;
    /**
      * `Remove photo`
      */
    ["Remove photo"](): string;
    /**
      * `Remove special filter`
      */
    ["Remove special filter"](): string;
    /**
      * `Removed from Favourites`
      */
    ["Removed from Favorites"](): string;
    /**
      * `Removed successfully`
      */
    ["Removed successfully"](): string;
    /**
      * `Rename`
      */
    Rename(): string;
    /**
      * `Restart to install update`
      */
    ["Restart Install Client Update"](): string;
    /**
      * `Restore it`
      */
    ["Restore it"](): string;
    /**
      * `Retain cached cloud data`
      */
    ["Retain cached cloud data"](): string;
    /**
      * `Retain local cached data`
      */
    ["Retain local cached data"](): string;
    /**
      * `Save`
      */
    Save(): string;
    /**
      * `Save As New Collection`
      */
    ["Save As New Collection"](): string;
    /**
      * `Save as New Collection`
      */
    ["Save as New Collection"](): string;
    /**
      * `All changes are saved locally, click to enable AFFiNE Cloud.`
      */
    ["Saved then enable AFFiNE Cloud"](): string;
    /**
      * `Select`
      */
    Select(): string;
    /**
      * `Select All`
      */
    ["Select All"](): string;
    /**
      * `Set a Workspace name`
      */
    ["Set a Workspace name"](): string;
    /**
      * `Set database location`
      */
    ["Set database location"](): string;
    /**
      * `Set up an AFFiNE account to sync data`
      */
    ["Set up an AFFiNE account to sync data"](): string;
    /**
      * `Settings`
      */
    Settings(): string;
    /**
      * `Shape`
      */
    Shape(): string;
    /**
      * `Invite others to join the Workspace or publish it to web.`
      */
    ["Share Menu Public Workspace Description1"](): string;
    /**
      * `Current workspace has been published to the web as a public workspace.`
      */
    ["Share Menu Public Workspace Description2"](): string;
    /**
      * `Share with link`
      */
    ["Share with link"](): string;
    /**
      * `Shared Docs`
      */
    ["Shared Pages"](): string;
    /**
      * `Sharing doc publicly requires AFFiNE Cloud service.`
      */
    ["Shared Pages Description"](): string;
    /**
      * `Shortcuts`
      */
    Shortcuts(): string;
    /**
      * `Sidebar`
      */
    Sidebar(): string;
    /**
      * `Sign in AFFiNE Cloud`
      */
    ["Sign in"](): string;
    /**
      * `Sign in and Enable`
      */
    ["Sign in and Enable"](): string;
    /**
      * `Sign out`
      */
    ["Sign out"](): string;
    /**
      * `Signing out will cause the unsynchronised content to be lost.`
      */
    ["Sign out description"](): string;
    /**
      * `Skip`
      */
    Skip(): string;
    /**
      * `Start Week On Monday`
      */
    ["Start Week On Monday"](): string;
    /**
      * `Stay logged out`
      */
    ["Stay logged out"](): string;
    /**
      * `Sticky`
      */
    Sticky(): string;
    /**
      * `Stop publishing`
      */
    ["Stop publishing"](): string;
    /**
      * `Storage`
      */
    Storage(): string;
    /**
      * `Storage Folder`
      */
    ["Storage Folder"](): string;
    /**
      * `Storage and Export`
      */
    ["Storage and Export"](): string;
    /**
      * `Straight Connector`
      */
    ["Straight Connector"](): string;
    /**
      * `Strikethrough`
      */
    Strikethrough(): string;
    /**
      * `Successfully deleted`
      */
    ["Successfully deleted"](): string;
    /**
      * `Successfully enabled AFFiNE Cloud`
      */
    ["Successfully enabled AFFiNE Cloud"](): string;
    /**
      * `Successfully joined!`
      */
    ["Successfully joined!"](): string;
    /**
      * `Switch`
      */
    Switch(): string;
    /**
      * `Sync`
      */
    Sync(): string;
    /**
      * `Sync across devices with AFFiNE Cloud`
      */
    ["Sync across devices with AFFiNE Cloud"](): string;
    /**
      * `Synced with AFFiNE Cloud`
      */
    ["Synced with AFFiNE Cloud"](): string;
    /**
      * `Tags`
      */
    Tags(): string;
    /**
      * `Terms of Use`
      */
    ["Terms of Use"](): string;
    /**
      * `Text`
      */
    Text(): string;
    /**
      * `Theme`
      */
    Theme(): string;
    /**
      * `Title`
      */
    Title(): string;
    /**
      * `Trash`
      */
    Trash(): string;
    /**
      * `Once deleted, you can't undo this action. Do you confirm?`
      */
    TrashButtonGroupDescription(): string;
    /**
      * `Permanently delete`
      */
    TrashButtonGroupTitle(): string;
    /**
      * `Unknown error`
      */
    UNKNOWN_ERROR(): string;
    /**
      * `Underline`
      */
    Underline(): string;
    /**
      * `Undo`
      */
    Undo(): string;
    /**
      * `Ungroup`
      */
    Ungroup(): string;
    /**
      * `Unpin`
      */
    Unpin(): string;
    /**
      * `Once published to the web, visitors can view the contents through the provided link.`
      */
    ["Unpublished hint"](): string;
    /**
      * `Untitled`
      */
    Untitled(): string;
    /**
      * `Untitled Collection`
      */
    ["Untitled Collection"](): string;
    /**
      * `Update available`
      */
    ["Update Available"](): string;
    /**
      * `Update Collection`
      */
    ["Update Collection"](): string;
    /**
      * `Update workspace name success`
      */
    ["Update workspace name success"](): string;
    /**
      * `Updated`
      */
    Updated(): string;
    /**
      * `Upload`
      */
    Upload(): string;
    /**
      * `Use on current device only`
      */
    ["Use on current device only"](): string;
    /**
      * `Users`
      */
    Users(): string;
    /**
      * `Version`
      */
    Version(): string;
    /**
      * `View Navigation Path`
      */
    ["View Navigation Path"](): string;
    /**
      * `Visit Workspace`
      */
    ["Visit Workspace"](): string;
    /**
      * `Wait for Sync`
      */
    ["Wait for Sync"](): string;
    /**
      * `Window frame style`
      */
    ["Window frame style"](): string;
    /**
      * `Workspace Avatar`
      */
    ["Workspace Avatar"](): string;
    /**
      * `Workspace Icon`
      */
    ["Workspace Icon"](): string;
    /**
      * `Workspace Name`
      */
    ["Workspace Name"](): string;
    /**
      * `Workspace Not Found`
      */
    ["Workspace Not Found"](): string;
    /**
      * `Workspace Owner`
      */
    ["Workspace Owner"](): string;
    /**
      * `Workspace Profile`
      */
    ["Workspace Profile"](): string;
    /**
      * `Workspace Settings`
      */
    ["Workspace Settings"](): string;
    /**
      * `{{name}}'s Settings`
      */
    ["Workspace Settings with name"](options: {
        readonly name: string;
    }): string;
    /**
      * `Workspace Type`
      */
    ["Workspace Type"](): string;
    /**
      * `Select where you want to create your workspace. The data of workspace is saved locally by default.`
      */
    ["Workspace database storage description"](): string;
    /**
      * `A workspace is your virtual space to capture, create and plan as just one person or together as a team.`
      */
    ["Workspace description"](): string;
    /**
      * `{{name}} is saved locally`
      */
    ["Workspace saved locally"](options: {
        readonly name: string;
    }): string;
    /**
      * `You cannot delete the last workspace`
      */
    ["You cannot delete the last workspace"](): string;
    /**
      * `Zoom in`
      */
    ["Zoom in"](): string;
    /**
      * `Zoom out`
      */
    ["Zoom out"](): string;
    /**
      * `Zoom to 100%`
      */
    ["Zoom to 100%"](): string;
    /**
      * `Zoom to fit`
      */
    ["Zoom to fit"](): string;
    /**
      * `all`
      */
    all(): string;
    /**
      * `Automatically check for new updates periodically.`
      */
    ["com.affine.aboutAFFiNE.autoCheckUpdate.description"](): string;
    /**
      * `Check for updates automatically`
      */
    ["com.affine.aboutAFFiNE.autoCheckUpdate.title"](): string;
    /**
      * `Automatically download updates (to this device).`
      */
    ["com.affine.aboutAFFiNE.autoDownloadUpdate.description"](): string;
    /**
      * `Download updates automatically`
      */
    ["com.affine.aboutAFFiNE.autoDownloadUpdate.title"](): string;
    /**
      * `View the AFFiNE Changelog.`
      */
    ["com.affine.aboutAFFiNE.changelog.description"](): string;
    /**
      * `Discover what's new`
      */
    ["com.affine.aboutAFFiNE.changelog.title"](): string;
    /**
      * `Check for Update`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.button.check"](): string;
    /**
      * `Download Update`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.button.download"](): string;
    /**
      * `Restart to Update`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.button.restart"](): string;
    /**
      * `Retry`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.button.retry"](): string;
    /**
      * `New version is ready`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.description"](): string;
    /**
      * `Manually check for updates.`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.check"](): string;
    /**
      * `Checking for updates...`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.checking"](): string;
    /**
      * `Downloading the latest version...`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.downloading"](): string;
    /**
      * `Unable to connect to the update server.`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.error"](): string;
    /**
      * `You’ve got the latest version of AFFiNE.`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.latest"](): string;
    /**
      * `Restart to apply update.`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.restart"](): string;
    /**
      * `New update available ({{version}})`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.subtitle.update-available"](options: {
        readonly version: string;
    }): string;
    /**
      * `Check for updates`
      */
    ["com.affine.aboutAFFiNE.checkUpdate.title"](): string;
    /**
      * `Communities`
      */
    ["com.affine.aboutAFFiNE.community.title"](): string;
    /**
      * `AFFiNE Community`
      */
    ["com.affine.aboutAFFiNE.contact.community"](): string;
    /**
      * `Contact Us`
      */
    ["com.affine.aboutAFFiNE.contact.title"](): string;
    /**
      * `Official Website`
      */
    ["com.affine.aboutAFFiNE.contact.website"](): string;
    /**
      * `Privacy`
      */
    ["com.affine.aboutAFFiNE.legal.privacy"](): string;
    /**
      * `Legal Info`
      */
    ["com.affine.aboutAFFiNE.legal.title"](): string;
    /**
      * `Terms of Use`
      */
    ["com.affine.aboutAFFiNE.legal.tos"](): string;
    /**
      * `Information about AFFiNE`
      */
    ["com.affine.aboutAFFiNE.subtitle"](): string;
    /**
      * `About AFFiNE`
      */
    ["com.affine.aboutAFFiNE.title"](): string;
    /**
      * `App Version`
      */
    ["com.affine.aboutAFFiNE.version.app"](): string;
    /**
      * `Editor Version`
      */
    ["com.affine.aboutAFFiNE.version.editor.title"](): string;
    /**
      * `Version`
      */
    ["com.affine.aboutAFFiNE.version.title"](): string;
    /**
      * `Lets you think bigger, create faster, work smarter and save time for every project.`
      */
    ["com.affine.ai-onboarding.edgeless.message"](): string;
    /**
      * `Right-clicking to select content AI`
      */
    ["com.affine.ai-onboarding.edgeless.title"](): string;
    /**
      * `Lets you think bigger, create faster, work smarter and save time for every project.`
      */
    ["com.affine.ai-onboarding.general.1.description"](): string;
    /**
      * `Meet AFFiNE AI`
      */
    ["com.affine.ai-onboarding.general.1.title"](): string;
    /**
      * `Answer questions, draft docs, visualize ideas - AFFiNE AI can save you time at every possible step. Powered by GPT’s most powerful model.`
      */
    ["com.affine.ai-onboarding.general.2.description"](): string;
    /**
      * `Chat with AFFiNE AI`
      */
    ["com.affine.ai-onboarding.general.2.title"](): string;
    /**
      * `Get insightful answer to any question, instantly.`
      */
    ["com.affine.ai-onboarding.general.3.description"](): string;
    /**
      * `Edit Inline with AFFiNE AI`
      */
    ["com.affine.ai-onboarding.general.3.title"](): string;
    /**
      * `Expand thinking. Untangle complexity. Breakdown and visualise your content with crafted mindmap and presentable slides with one click.`
      */
    ["com.affine.ai-onboarding.general.4.description"](): string;
    /**
      * `Make mind-map and Presents with AI`
      */
    ["com.affine.ai-onboarding.general.4.title"](): string;
    /**
      * `AFFiNE AI is ready`
      */
    ["com.affine.ai-onboarding.general.5.title"](): string;
    /**
      * `Get Started`
      */
    ["com.affine.ai-onboarding.general.get-started"](): string;
    /**
      * `Next`
      */
    ["com.affine.ai-onboarding.general.next"](): string;
    /**
      * `Back`
      */
    ["com.affine.ai-onboarding.general.prev"](): string;
    /**
      * `Get Unlimited Usage`
      */
    ["com.affine.ai-onboarding.general.purchase"](): string;
    /**
      * `Remind me Later`
      */
    ["com.affine.ai-onboarding.general.skip"](): string;
    /**
      * `Try for Free`
      */
    ["com.affine.ai-onboarding.general.try-for-free"](): string;
    /**
      * `Get Started`
      */
    ["com.affine.ai-onboarding.local.action-get-started"](): string;
    /**
      * `Learn More`
      */
    ["com.affine.ai-onboarding.local.action-learn-more"](): string;
    /**
      * `Lets you think bigger, create faster, work smarter and save time for every project.`
      */
    ["com.affine.ai-onboarding.local.message"](): string;
    /**
      * `Meet AFFiNE AI`
      */
    ["com.affine.ai-onboarding.local.title"](): string;
    /**
      * `Please switch to edgeless mode`
      */
    ["com.affine.ai.action.edgeless-only.dialog-title"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.ai.login-required.dialog-cancel"](): string;
    /**
      * `Sign in`
      */
    ["com.affine.ai.login-required.dialog-confirm"](): string;
    /**
      * `To use AFFiNE AI, please sign in to your AFFiNE Cloud account.`
      */
    ["com.affine.ai.login-required.dialog-content"](): string;
    /**
      * `Sign in to Continue`
      */
    ["com.affine.ai.login-required.dialog-title"](): string;
    /**
      * `All Docs`
      */
    ["com.affine.all-pages.header"](): string;
    /**
      * `Download update`
      */
    ["com.affine.appUpdater.downloadUpdate"](): string;
    /**
      * `Downloading`
      */
    ["com.affine.appUpdater.downloading"](): string;
    /**
      * `Restart to install update`
      */
    ["com.affine.appUpdater.installUpdate"](): string;
    /**
      * `Open download page`
      */
    ["com.affine.appUpdater.openDownloadPage"](): string;
    /**
      * `Update available`
      */
    ["com.affine.appUpdater.updateAvailable"](): string;
    /**
      * `Discover what's new!`
      */
    ["com.affine.appUpdater.whatsNew"](): string;
    /**
      * `Customise the appearance of the client.`
      */
    ["com.affine.appearanceSettings.clientBorder.description"](): string;
    /**
      * `Client Border Style`
      */
    ["com.affine.appearanceSettings.clientBorder.title"](): string;
    /**
      * `Choose your colour mode`
      */
    ["com.affine.appearanceSettings.color.description"](): string;
    /**
      * `Colour Mode`
      */
    ["com.affine.appearanceSettings.color.title"](): string;
    /**
      * `Date`
      */
    ["com.affine.appearanceSettings.date.title"](): string;
    /**
      * `Customise your date style.`
      */
    ["com.affine.appearanceSettings.dateFormat.description"](): string;
    /**
      * `Date Format`
      */
    ["com.affine.appearanceSettings.dateFormat.title"](): string;
    /**
      * `Choose your font style`
      */
    ["com.affine.appearanceSettings.font.description"](): string;
    /**
      * `Font Style`
      */
    ["com.affine.appearanceSettings.font.title"](): string;
    /**
      * `Mono`
      */
    ["com.affine.appearanceSettings.fontStyle.mono"](): string;
    /**
      * `Sans`
      */
    ["com.affine.appearanceSettings.fontStyle.sans"](): string;
    /**
      * `Serif`
      */
    ["com.affine.appearanceSettings.fontStyle.serif"](): string;
    /**
      * `Maximum display of content within a doc.`
      */
    ["com.affine.appearanceSettings.fullWidth.description"](): string;
    /**
      * `Full width Layout`
      */
    ["com.affine.appearanceSettings.fullWidth.title"](): string;
    /**
      * `Select the language for the interface.`
      */
    ["com.affine.appearanceSettings.language.description"](): string;
    /**
      * `Display Language`
      */
    ["com.affine.appearanceSettings.language.title"](): string;
    /**
      * `Use background noise effect on the sidebar.`
      */
    ["com.affine.appearanceSettings.noisyBackground.description"](): string;
    /**
      * `Noise background on the sidebar`
      */
    ["com.affine.appearanceSettings.noisyBackground.title"](): string;
    /**
      * `Sidebar`
      */
    ["com.affine.appearanceSettings.sidebar.title"](): string;
    /**
      * `By default, the week starts on Sunday.`
      */
    ["com.affine.appearanceSettings.startWeek.description"](): string;
    /**
      * `Start Week On Monday`
      */
    ["com.affine.appearanceSettings.startWeek.title"](): string;
    /**
      * `Customise your  AFFiNE Appearance`
      */
    ["com.affine.appearanceSettings.subtitle"](): string;
    /**
      * `Theme`
      */
    ["com.affine.appearanceSettings.theme.title"](): string;
    /**
      * `Appearance Settings`
      */
    ["com.affine.appearanceSettings.title"](): string;
    /**
      * `Use transparency effect on the sidebar.`
      */
    ["com.affine.appearanceSettings.translucentUI.description"](): string;
    /**
      * `Translucent UI on the sidebar`
      */
    ["com.affine.appearanceSettings.translucentUI.title"](): string;
    /**
      * `Native Titlebar`
      */
    ["com.affine.appearanceSettings.windowFrame.NativeTitleBar"](): string;
    /**
      * `Customise appearance of Windows Client.`
      */
    ["com.affine.appearanceSettings.windowFrame.description"](): string;
    /**
      * `Frameless`
      */
    ["com.affine.appearanceSettings.windowFrame.frameless"](): string;
    /**
      * `Window frame style`
      */
    ["com.affine.appearanceSettings.windowFrame.title"](): string;
    /**
      * `Your current email is {{email}}. We’ll send a temporary verification link to this email.`
      */
    ["com.affine.auth.change.email.message"](options: {
        readonly email: string;
    }): string;
    /**
      * `Please enter your new email address below. We will send a verification link to this email address to complete the process.`
      */
    ["com.affine.auth.change.email.page.subtitle"](): string;
    /**
      * `Congratulations! You have successfully updated the email address associated with your AFFiNE Cloud account.`
      */
    ["com.affine.auth.change.email.page.success.subtitle"](): string;
    /**
      * `Email address updated!`
      */
    ["com.affine.auth.change.email.page.success.title"](): string;
    /**
      * `Change email address`
      */
    ["com.affine.auth.change.email.page.title"](): string;
    /**
      * `Create Account`
      */
    ["com.affine.auth.create.count"](): string;
    /**
      * `Signing in...`
      */
    ["com.affine.auth.desktop.signing.in"](): string;
    /**
      * `Forgot password`
      */
    ["com.affine.auth.forget"](): string;
    /**
      * `Signed in`
      */
    ["com.affine.auth.has.signed"](): string;
    /**
      * `You have been signed in, start to sync your data with AFFiNE Cloud!`
      */
    ["com.affine.auth.has.signed.message"](): string;
    /**
      * `Later`
      */
    ["com.affine.auth.later"](): string;
    /**
      * `Open AFFiNE`
      */
    ["com.affine.auth.open.affine"](): string;
    /**
      * `Download App`
      */
    ["com.affine.auth.open.affine.download-app"](): string;
    /**
      * `Try again`
      */
    ["com.affine.auth.open.affine.try-again"](): string;
    /**
      * `Please set a password of {{min}}-{{max}} characters with both letters and numbers to continue signing up with `
      */
    ["com.affine.auth.page.sent.email.subtitle"](options: Readonly<{
        min: string;
        max: string;
    }>): string;
    /**
      * `Welcome to AFFiNE Cloud, you are almost there!`
      */
    ["com.affine.auth.page.sent.email.title"](): string;
    /**
      * `Password`
      */
    ["com.affine.auth.password"](): string;
    /**
      * `Invalid password`
      */
    ["com.affine.auth.password.error"](): string;
    /**
      * `Set Password Failed`
      */
    ["com.affine.auth.password.set-failed"](): string;
    /**
      * `Reset Password`
      */
    ["com.affine.auth.reset.password"](): string;
    /**
      * `You will receive an email with a link to reset your password. Please check your inbox.`
      */
    ["com.affine.auth.reset.password.message"](): string;
    /**
      * `Password reset successful`
      */
    ["com.affine.auth.reset.password.page.success"](): string;
    /**
      * `Reset your AFFiNE Cloud password`
      */
    ["com.affine.auth.reset.password.page.title"](): string;
    /**
      * `Send verification link`
      */
    ["com.affine.auth.send.change.email.link"](): string;
    /**
      * `Send reset link`
      */
    ["com.affine.auth.send.reset.password.link"](): string;
    /**
      * `Send set link`
      */
    ["com.affine.auth.send.set.password.link"](): string;
    /**
      * `Send verification link`
      */
    ["com.affine.auth.send.verify.email.hint"](): string;
    /**
      * `Sent`
      */
    ["com.affine.auth.sent"](): string;
    /**
      * `The verification link failed to be sent, please try again later.`
      */
    ["com.affine.auth.sent.change.email.fail"](): string;
    /**
      * `Verification link has been sent.`
      */
    ["com.affine.auth.sent.change.email.hint"](): string;
    /**
      * `Reset password link has been sent.`
      */
    ["com.affine.auth.sent.change.password.hint"](): string;
    /**
      * `Your password has upgraded! You can sign in AFFiNE Cloud with new password!`
      */
    ["com.affine.auth.sent.reset.password.success.message"](): string;
    /**
      * `Set password link has been sent.`
      */
    ["com.affine.auth.sent.set.password.hint"](): string;
    /**
      * `Your password has saved! You can sign in AFFiNE Cloud with email and password!`
      */
    ["com.affine.auth.sent.set.password.success.message"](): string;
    /**
      * `Verification link has been sent.`
      */
    ["com.affine.auth.sent.verify.email.hint"](): string;
    /**
      * `Save Email`
      */
    ["com.affine.auth.set.email.save"](): string;
    /**
      * `Set password`
      */
    ["com.affine.auth.set.password"](): string;
    /**
      * `Please set a password of {{min}}-{{max}} characters with both letters and numbers to continue signing up with `
      */
    ["com.affine.auth.set.password.message"](options: Readonly<{
        min: string;
        max: string;
    }>): string;
    /**
      * `Maximum {{max}} characters`
      */
    ["com.affine.auth.set.password.message.maxlength"](options: {
        readonly max: string;
    }): string;
    /**
      * `Minimum {{min}} characters`
      */
    ["com.affine.auth.set.password.message.minlength"](options: {
        readonly min: string;
    }): string;
    /**
      * `Password set successful`
      */
    ["com.affine.auth.set.password.page.success"](): string;
    /**
      * `Set your AFFiNE Cloud password`
      */
    ["com.affine.auth.set.password.page.title"](): string;
    /**
      * `Set a password at least {{min}} letters long`
      */
    ["com.affine.auth.set.password.placeholder"](options: {
        readonly min: string;
    }): string;
    /**
      * `Confirm password`
      */
    ["com.affine.auth.set.password.placeholder.confirm"](): string;
    /**
      * `Save Password`
      */
    ["com.affine.auth.set.password.save"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.auth.sign-out.confirm-modal.cancel"](): string;
    /**
      * `Sign Out`
      */
    ["com.affine.auth.sign-out.confirm-modal.confirm"](): string;
    /**
      * `After signing out, the Cloud Workspaces associated with this account will be removed from the current device, and signing in again will add them back.`
      */
    ["com.affine.auth.sign-out.confirm-modal.description"](): string;
    /**
      * `Sign out?`
      */
    ["com.affine.auth.sign-out.confirm-modal.title"](): string;
    /**
      * `Wrong code, please try again`
      */
    ["com.affine.auth.sign.auth.code.error.hint"](): string;
    /**
      * `If you haven't received the email, please check your spam folder.`
      */
    ["com.affine.auth.sign.auth.code.message"](): string;
    /**
      * `Send code again`
      */
    ["com.affine.auth.sign.auth.code.on.resend.hint"](): string;
    /**
      * `Resend link`
      */
    ["com.affine.auth.sign.auth.code.resend.hint"](): string;
    /**
      * `Sign in with magic link`
      */
    ["com.affine.auth.sign.auth.code.send-email.sign-in"](): string;
    /**
      * `Terms of Conditions`
      */
    ["com.affine.auth.sign.condition"](): string;
    /**
      * `Continue with Email`
      */
    ["com.affine.auth.sign.email.continue"](): string;
    /**
      * `Invalid email`
      */
    ["com.affine.auth.sign.email.error"](): string;
    /**
      * `Enter your email address`
      */
    ["com.affine.auth.sign.email.placeholder"](): string;
    /**
      * `Sign in`
      */
    ["com.affine.auth.sign.in"](): string;
    /**
      * `Confirm your email`
      */
    ["com.affine.auth.sign.in.sent.email.subtitle"](): string;
    /**
      * `AFFiNE Cloud is in early access. Check out this link to learn more about the benefits of becoming an AFFiNE Cloud Early Supporter: `
      */
    ["com.affine.auth.sign.no.access.hint"](): string;
    /**
      * `AFFiNE Cloud Early Access`
      */
    ["com.affine.auth.sign.no.access.link"](): string;
    /**
      * `Wait for public release`
      */
    ["com.affine.auth.sign.no.access.wait"](): string;
    /**
      * `Privacy Policy`
      */
    ["com.affine.auth.sign.policy"](): string;
    /**
      * ` You can click the link to create an account automatically.`
      */
    ["com.affine.auth.sign.sent.email.message.end"](): string;
    /**
      * `You can click the link to sign in automatically.`
      */
    ["com.affine.auth.sign.sent.email.message.sent-tips.sign-in"](): string;
    /**
      * `You can click the link to create an account automatically.`
      */
    ["com.affine.auth.sign.sent.email.message.sent-tips.sign-up"](): string;
    /**
      * `Sign up`
      */
    ["com.affine.auth.sign.up"](): string;
    /**
      * `Create your account`
      */
    ["com.affine.auth.sign.up.sent.email.subtitle"](): string;
    /**
      * `The app will automatically open or redirect to the web version. If you encounter any issues, you can also click the button below to manually open the AFFiNE app.`
      */
    ["com.affine.auth.sign.up.success.subtitle"](): string;
    /**
      * `Your account has been created and you’re now signed in!`
      */
    ["com.affine.auth.sign.up.success.title"](): string;
    /**
      * `You have successfully signed in. The app will automatically open or redirect to the web version. if you encounter any issues, you can also click the button below to  manually open the AFFiNE app.`
      */
    ["com.affine.auth.signed.success.subtitle"](): string;
    /**
      * `You’re almost there!`
      */
    ["com.affine.auth.signed.success.title"](): string;
    /**
      * `Server error, please try again later.`
      */
    ["com.affine.auth.toast.message.failed"](): string;
    /**
      * `You have been signed in, start to sync your data with AFFiNE Cloud!`
      */
    ["com.affine.auth.toast.message.signed-in"](): string;
    /**
      * `Unable to sign in`
      */
    ["com.affine.auth.toast.title.failed"](): string;
    /**
      * `Signed in`
      */
    ["com.affine.auth.toast.title.signed-in"](): string;
    /**
      * `Your current email is {{email}}. We’ll send a temporary verification link to this email.`
      */
    ["com.affine.auth.verify.email.message"](options: {
        readonly email: string;
    }): string;
    /**
      * `Congratulations! You have successfully verified the email address associated with your AFFiNE Cloud account.`
      */
    ["com.affine.auth.verify.email.page.success.subtitle"](): string;
    /**
      * `Email address verified!`
      */
    ["com.affine.auth.verify.email.page.success.title"](): string;
    /**
      * `Back`
      */
    ["com.affine.backButton"](): string;
    /**
      * `Your local data is stored in the browser and may be lost. Don't risk it - enable cloud now!`
      */
    ["com.affine.banner.local-warning"](): string;
    /**
      * `AFFiNE Cloud`
      */
    ["com.affine.brand.affineCloud"](): string;
    /**
      * `Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec`
      */
    ["com.affine.calendar-date-picker.month-names"](): string;
    /**
      * `Today`
      */
    ["com.affine.calendar-date-picker.today"](): string;
    /**
      * `Su,Mo,Tu,We,Th,Fr,Sa`
      */
    ["com.affine.calendar-date-picker.week-days"](): string;
    /**
      * `Fri`
      */
    ["com.affine.calendar.weekdays.fri"](): string;
    /**
      * `Mon`
      */
    ["com.affine.calendar.weekdays.mon"](): string;
    /**
      * `Sat`
      */
    ["com.affine.calendar.weekdays.sat"](): string;
    /**
      * `Sun`
      */
    ["com.affine.calendar.weekdays.sun"](): string;
    /**
      * `Thu`
      */
    ["com.affine.calendar.weekdays.thu"](): string;
    /**
      * `Tue`
      */
    ["com.affine.calendar.weekdays.tue"](): string;
    /**
      * `Wed`
      */
    ["com.affine.calendar.weekdays.wed"](): string;
    /**
      * `AFFiNE Cloud is upgrading now.`
      */
    ["com.affine.cloudTempDisable.title"](): string;
    /**
      * `Collections`
      */
    ["com.affine.cmdk.affine.category.affine.collections"](): string;
    /**
      * `Create`
      */
    ["com.affine.cmdk.affine.category.affine.creation"](): string;
    /**
      * `Edgeless`
      */
    ["com.affine.cmdk.affine.category.affine.edgeless"](): string;
    /**
      * `General`
      */
    ["com.affine.cmdk.affine.category.affine.general"](): string;
    /**
      * `Help`
      */
    ["com.affine.cmdk.affine.category.affine.help"](): string;
    /**
      * `Layout Controls`
      */
    ["com.affine.cmdk.affine.category.affine.layout"](): string;
    /**
      * `Navigation`
      */
    ["com.affine.cmdk.affine.category.affine.navigation"](): string;
    /**
      * `Docs`
      */
    ["com.affine.cmdk.affine.category.affine.pages"](): string;
    /**
      * `Recent`
      */
    ["com.affine.cmdk.affine.category.affine.recent"](): string;
    /**
      * `Settings`
      */
    ["com.affine.cmdk.affine.category.affine.settings"](): string;
    /**
      * `Updates`
      */
    ["com.affine.cmdk.affine.category.affine.updates"](): string;
    /**
      * `Edgeless Commands`
      */
    ["com.affine.cmdk.affine.category.editor.edgeless"](): string;
    /**
      * `Insert Object`
      */
    ["com.affine.cmdk.affine.category.editor.insert-object"](): string;
    /**
      * `Doc Commands`
      */
    ["com.affine.cmdk.affine.category.editor.page"](): string;
    /**
      * `Results`
      */
    ["com.affine.cmdk.affine.category.results"](): string;
    /**
      * `Change Client Border Style to`
      */
    ["com.affine.cmdk.affine.client-border-style.to"](): string;
    /**
      * `Change Colour Mode to`
      */
    ["com.affine.cmdk.affine.color-mode.to"](): string;
    /**
      * `Change Colour Scheme to`
      */
    ["com.affine.cmdk.affine.color-scheme.to"](): string;
    /**
      * `Contact Us`
      */
    ["com.affine.cmdk.affine.contact-us"](): string;
    /**
      * `New "{{keyWord}}" Edgeless`
      */
    ["com.affine.cmdk.affine.create-new-edgeless-as"](options: {
        readonly keyWord: string;
    }): string;
    /**
      * `New "{{keyWord}}" Page`
      */
    ["com.affine.cmdk.affine.create-new-page-as"](options: {
        readonly keyWord: string;
    }): string;
    /**
      * `Change Display Language to`
      */
    ["com.affine.cmdk.affine.display-language.to"](): string;
    /**
      * `Add to Favourites`
      */
    ["com.affine.cmdk.affine.editor.add-to-favourites"](): string;
    /**
      * `Start Presentation`
      */
    ["com.affine.cmdk.affine.editor.edgeless.presentation-start"](): string;
    /**
      * `Remove from Favourites`
      */
    ["com.affine.cmdk.affine.editor.remove-from-favourites"](): string;
    /**
      * `Restore from Trash`
      */
    ["com.affine.cmdk.affine.editor.restore-from-trash"](): string;
    /**
      * `Reveal Doc History Modal`
      */
    ["com.affine.cmdk.affine.editor.reveal-page-history-modal"](): string;
    /**
      * `This doc has been moved to the trash, you can either restore or permanently delete it.`
      */
    ["com.affine.cmdk.affine.editor.trash-footer-hint"](): string;
    /**
      * `Change Font Style to`
      */
    ["com.affine.cmdk.affine.font-style.to"](): string;
    /**
      * `Change Full Width Layout to`
      */
    ["com.affine.cmdk.affine.full-width-layout.to"](): string;
    /**
      * `Getting Started`
      */
    ["com.affine.cmdk.affine.getting-started"](): string;
    /**
      * `Import Workspace`
      */
    ["com.affine.cmdk.affine.import-workspace"](): string;
    /**
      * `Collapse Left Sidebar`
      */
    ["com.affine.cmdk.affine.left-sidebar.collapse"](): string;
    /**
      * `Expand Left Sidebar`
      */
    ["com.affine.cmdk.affine.left-sidebar.expand"](): string;
    /**
      * `Go to All Docs`
      */
    ["com.affine.cmdk.affine.navigation.goto-all-pages"](): string;
    /**
      * `Go to Edgeless List`
      */
    ["com.affine.cmdk.affine.navigation.goto-edgeless-list"](): string;
    /**
      * `Go to Page List`
      */
    ["com.affine.cmdk.affine.navigation.goto-page-list"](): string;
    /**
      * `Go to Trash`
      */
    ["com.affine.cmdk.affine.navigation.goto-trash"](): string;
    /**
      * `Go to Workspace`
      */
    ["com.affine.cmdk.affine.navigation.goto-workspace"](): string;
    /**
      * `Go to Settings`
      */
    ["com.affine.cmdk.affine.navigation.open-settings"](): string;
    /**
      * `Go to Account Settings`
      */
    ["com.affine.cmdk.affine.navigation.open-account-settings"](): string;
    /**
      * `New Edgeless`
      */
    ["com.affine.cmdk.affine.new-edgeless-page"](): string;
    /**
      * `New Page`
      */
    ["com.affine.cmdk.affine.new-page"](): string;
    /**
      * `New Workspace`
      */
    ["com.affine.cmdk.affine.new-workspace"](): string;
    /**
      * `Change Noise Background On The Sidebar to`
      */
    ["com.affine.cmdk.affine.noise-background-on-the-sidebar.to"](): string;
    /**
      * `Restart to Upgrade`
      */
    ["com.affine.cmdk.affine.restart-to-upgrade"](): string;
    /**
      * `OFF`
      */
    ["com.affine.cmdk.affine.switch-state.off"](): string;
    /**
      * `ON`
      */
    ["com.affine.cmdk.affine.switch-state.on"](): string;
    /**
      * `Change Translucent UI On The Sidebar to`
      */
    ["com.affine.cmdk.affine.translucent-ui-on-the-sidebar.to"](): string;
    /**
      * `What's New`
      */
    ["com.affine.cmdk.affine.whats-new"](): string;
    /**
      * `Type a command or search anything...`
      */
    ["com.affine.cmdk.placeholder"](): string;
    /**
      * `Delete`
      */
    ["com.affine.collection-bar.action.tooltip.delete"](): string;
    /**
      * `Edit`
      */
    ["com.affine.collection-bar.action.tooltip.edit"](): string;
    /**
      * `Pin to Sidebar`
      */
    ["com.affine.collection-bar.action.tooltip.pin"](): string;
    /**
      * `Unpin`
      */
    ["com.affine.collection-bar.action.tooltip.unpin"](): string;
    /**
      * `Do you want to add a document to the current collection? If it is filtered based on rules, this will add a set of included rules.`
      */
    ["com.affine.collection.add-doc.confirm.description"](): string;
    /**
      * `Add new doc to this collection`
      */
    ["com.affine.collection.add-doc.confirm.title"](): string;
    /**
      * `Doc already exists`
      */
    ["com.affine.collection.addPage.alreadyExists"](): string;
    /**
      * `Added successfully`
      */
    ["com.affine.collection.addPage.success"](): string;
    /**
      * `Add Docs`
      */
    ["com.affine.collection.addPages"](): string;
    /**
      * `Add Rules`
      */
    ["com.affine.collection.addRules"](): string;
    /**
      * `All Collections`
      */
    ["com.affine.collection.allCollections"](): string;
    /**
      * `Empty Collection`
      */
    ["com.affine.collection.emptyCollection"](): string;
    /**
      * `Collection is a smart folder where you can manually add docs or automatically add docs through rules.`
      */
    ["com.affine.collection.emptyCollectionDescription"](): string;
    /**
      * `HELP INFO`
      */
    ["com.affine.collection.helpInfo"](): string;
    /**
      * `Edit Collection`
      */
    ["com.affine.collection.menu.edit"](): string;
    /**
      * `Rename`
      */
    ["com.affine.collection.menu.rename"](): string;
    /**
      * `Removed successfully`
      */
    ["com.affine.collection.removePage.success"](): string;
    /**
      * `Back to all`
      */
    ["com.affine.collectionBar.backToAll"](): string;
    /**
      * `No collections`
      */
    ["com.affine.collections.empty.message"](): string;
    /**
      * `New Collection`
      */
    ["com.affine.collections.empty.new-collection-button"](): string;
    /**
      * `Collections`
      */
    ["com.affine.collections.header"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.confirmModal.button.cancel"](): string;
    /**
      * `Current Year`
      */
    ["com.affine.currentYear"](): string;
    /**
      * `Deleting {{count}} tags cannot be undone, please proceed with caution.`
      */
    ["com.affine.delete-tags.confirm.multi-tag-description"](options: {
        readonly count: string;
    }): string;
    /**
      * `Delete Tag?`
      */
    ["com.affine.delete-tags.confirm.title"](): string;
    /**
      * `{{count}} tag deleted`
    
      * - com.affine.delete-tags.count_one: `{{count}} tag deleted`
    
      * - com.affine.delete-tags.count_other: `{{count}} tags deleted`
      */
    ["com.affine.delete-tags.count"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `{{count}} tag deleted`
      */
    ["com.affine.delete-tags.count_one"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `{{count}} tags deleted`
      */
    ["com.affine.delete-tags.count_other"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `Delete workspace from this device and optionally delete all data.`
      */
    ["com.affine.deleteLeaveWorkspace.description"](): string;
    /**
      * `Leave Workspace`
      */
    ["com.affine.deleteLeaveWorkspace.leave"](): string;
    /**
      * `After you leave, you will not be able to access content within this workspace.`
      */
    ["com.affine.deleteLeaveWorkspace.leaveDescription"](): string;
    /**
      * `Docs`
      */
    ["com.affine.docs.header"](): string;
    /**
      * `Draw with a blank whiteboard`
      */
    ["com.affine.draw_with_a_blank_whiteboard"](): string;
    /**
      * `Earlier`
      */
    ["com.affine.earlier"](): string;
    /**
      * `Edgeless Mode`
      */
    ["com.affine.edgelessMode"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.editCollection.button.cancel"](): string;
    /**
      * `Create`
      */
    ["com.affine.editCollection.button.create"](): string;
    /**
      * `Create Collection`
      */
    ["com.affine.editCollection.createCollection"](): string;
    /**
      * `Filters`
      */
    ["com.affine.editCollection.filters"](): string;
    /**
      * `Docs`
      */
    ["com.affine.editCollection.pages"](): string;
    /**
      * `Clear selected`
      */
    ["com.affine.editCollection.pages.clear"](): string;
    /**
      * `Rename Collection`
      */
    ["com.affine.editCollection.renameCollection"](): string;
    /**
      * `Rules`
      */
    ["com.affine.editCollection.rules"](): string;
    /**
      * `No Results`
      */
    ["com.affine.editCollection.rules.empty.noResults"](): string;
    /**
      * `No docs meet the filtering rules`
      */
    ["com.affine.editCollection.rules.empty.noResults.tips"](): string;
    /**
      * `No Rules`
      */
    ["com.affine.editCollection.rules.empty.noRules"](): string;
    /**
      * `Add selected doc`
      */
    ["com.affine.editCollection.rules.include.add"](): string;
    /**
      * `is`
      */
    ["com.affine.editCollection.rules.include.is"](): string;
    /**
      * `Doc`
      */
    ["com.affine.editCollection.rules.include.page"](): string;
    /**
      * `“Selected docs” refers to manually adding docs rather than automatically adding them through rule matching. You can manually add docs through the “Add selected docs” option or by dragging and dropping.`
      */
    ["com.affine.editCollection.rules.include.tips"](): string;
    /**
      * `What is "Selected docs"？`
      */
    ["com.affine.editCollection.rules.include.tipsTitle"](): string;
    /**
      * `Selected docs`
      */
    ["com.affine.editCollection.rules.include.title"](): string;
    /**
      * `Preview`
      */
    ["com.affine.editCollection.rules.preview"](): string;
    /**
      * `Reset`
      */
    ["com.affine.editCollection.rules.reset"](): string;
    /**
      * `automatically`
      */
    ["com.affine.editCollection.rules.tips.highlight"](): string;
    /**
      * `Save`
      */
    ["com.affine.editCollection.save"](): string;
    /**
      * `Save as New Collection`
      */
    ["com.affine.editCollection.saveCollection"](): string;
    /**
      * `Search doc...`
      */
    ["com.affine.editCollection.search.placeholder"](): string;
    /**
      * `Untitled Collection`
      */
    ["com.affine.editCollection.untitledCollection"](): string;
    /**
      * `Update Collection`
      */
    ["com.affine.editCollection.updateCollection"](): string;
    /**
      * `Collection is a smart folder where you can manually add docs or automatically add docs through rules.`
      */
    ["com.affine.editCollectionName.createTips"](): string;
    /**
      * `Name`
      */
    ["com.affine.editCollectionName.name"](): string;
    /**
      * `Collection Name`
      */
    ["com.affine.editCollectionName.name.placeholder"](): string;
    /**
      * `Linked doc not found`
      */
    ["com.affine.editor.reference-not-found"](): string;
    /**
      * `Switch`
      */
    ["com.affine.editorModeSwitch.tooltip"](): string;
    /**
      * `There's no doc here yet`
      */
    ["com.affine.emptyDesc"](): string;
    /**
      * `There's no collection here yet`
      */
    ["com.affine.emptyDesc.collection"](): string;
    /**
      * `There's no tag here yet`
      */
    ["com.affine.emptyDesc.tag"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.enableAffineCloudModal.button.cancel"](): string;
    /**
      * `Doc content is missing`
      */
    ["com.affine.error.no-page-root.title"](): string;
    /**
      * `Refresh`
      */
    ["com.affine.error.page-not-found.title"](): string;
    /**
      * `Refetch`
      */
    ["com.affine.error.refetch"](): string;
    /**
      * `Reload`
      */
    ["com.affine.error.reload"](): string;
    /**
      * `Refresh`
      */
    ["com.affine.error.retry"](): string;
    /**
      * `Something is wrong...`
      */
    ["com.affine.error.unexpected-error.title"](): string;
    /**
      * `Please request a new reset password link.`
      */
    ["com.affine.expired.page.subtitle"](): string;
    /**
      * `This link has expired...`
      */
    ["com.affine.expired.page.title"](): string;
    /**
      * `Please try it again later.`
      */
    ["com.affine.export.error.message"](): string;
    /**
      * `Export failed due to an unexpected error`
      */
    ["com.affine.export.error.title"](): string;
    /**
      * `Please open the download folder to check.`
      */
    ["com.affine.export.success.message"](): string;
    /**
      * `Exported successfully`
      */
    ["com.affine.export.success.title"](): string;
    /**
      * `Add to favourites`
      */
    ["com.affine.favoritePageOperation.add"](): string;
    /**
      * `Remove from favourites`
      */
    ["com.affine.favoritePageOperation.remove"](): string;
    /**
      * `Filter`
      */
    ["com.affine.filter"](): string;
    /**
      * `after`
      */
    ["com.affine.filter.after"](): string;
    /**
      * `before`
      */
    ["com.affine.filter.before"](): string;
    /**
      * `contains all`
      */
    ["com.affine.filter.contains all"](): string;
    /**
      * `contains one of`
      */
    ["com.affine.filter.contains one of"](): string;
    /**
      * `does not contains all`
      */
    ["com.affine.filter.does not contains all"](): string;
    /**
      * `does not contains one of`
      */
    ["com.affine.filter.does not contains one of"](): string;
    /**
      * `Empty`
      */
    ["com.affine.filter.empty-tag"](): string;
    /**
      * `false`
      */
    ["com.affine.filter.false"](): string;
    /**
      * `is`
      */
    ["com.affine.filter.is"](): string;
    /**
      * `is empty`
      */
    ["com.affine.filter.is empty"](): string;
    /**
      * `is not empty`
      */
    ["com.affine.filter.is not empty"](): string;
    /**
      * `Favourited`
      */
    ["com.affine.filter.is-favourited"](): string;
    /**
      * `Shared`
      */
    ["com.affine.filter.is-public"](): string;
    /**
      * `last`
      */
    ["com.affine.filter.last"](): string;
    /**
      * `Save View`
      */
    ["com.affine.filter.save-view"](): string;
    /**
      * `true`
      */
    ["com.affine.filter.true"](): string;
    /**
      * `Add Filter`
      */
    ["com.affine.filterList.button.add"](): string;
    /**
      * `Add Tag`
      */
    ["com.affine.header.option.add-tag"](): string;
    /**
      * `Duplicate`
      */
    ["com.affine.header.option.duplicate"](): string;
    /**
      * `Contact us`
      */
    ["com.affine.helpIsland.contactUs"](): string;
    /**
      * `Getting started`
      */
    ["com.affine.helpIsland.gettingStarted"](): string;
    /**
      * `Help and Feedback`
      */
    ["com.affine.helpIsland.helpAndFeedback"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.history-vision.tips-modal.cancel"](): string;
    /**
      * `Enable AFFiNE Cloud`
      */
    ["com.affine.history-vision.tips-modal.confirm"](): string;
    /**
      * `The current workspace is a local workspace, and we do not support version history for it at the moment. You can enable AFFiNE Cloud. This will sync the workspace with the Cloud, allowing you to use this feature.`
      */
    ["com.affine.history-vision.tips-modal.description"](): string;
    /**
      * `History Vision Needs AFFiNE Cloud`
      */
    ["com.affine.history-vision.tips-modal.title"](): string;
    /**
      * `Back to doc`
      */
    ["com.affine.history.back-to-page"](): string;
    /**
      * `You are about to restore the current version of the doc to the latest version available. This action will overwrite any changes made prior to the latest version.`
      */
    ["com.affine.history.confirm-restore-modal.hint"](): string;
    /**
      * `Load More`
      */
    ["com.affine.history.confirm-restore-modal.load-more"](): string;
    /**
      * `LIMITED DOC HISTORY`
      */
    ["com.affine.history.confirm-restore-modal.plan-prompt.limited-title"](): string;
    /**
      * `HELP INFO`
      */
    ["com.affine.history.confirm-restore-modal.plan-prompt.title"](): string;
    /**
      * `Upgrade`
      */
    ["com.affine.history.confirm-restore-modal.pro-plan-prompt.upgrade"](): string;
    /**
      * `Restore`
      */
    ["com.affine.history.confirm-restore-modal.restore"](): string;
    /**
      * `This document is such a spring chicken, it hasn't sprouted a single historical sprig yet!`
      */
    ["com.affine.history.empty-prompt.description"](): string;
    /**
      * `Empty`
      */
    ["com.affine.history.empty-prompt.title"](): string;
    /**
      * `Restore current version`
      */
    ["com.affine.history.restore-current-version"](): string;
    /**
      * `Version History`
      */
    ["com.affine.history.version-history"](): string;
    /**
      * `View History Version`
      */
    ["com.affine.history.view-history-version"](): string;
    /**
      * `Support Markdown/Notion`
      */
    ["com.affine.import_file"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.inviteModal.button.cancel"](): string;
    /**
      * `Maybe Later`
      */
    ["com.affine.issue-feedback.cancel"](): string;
    /**
      * `Create Issue on GitHub`
      */
    ["com.affine.issue-feedback.confirm"](): string;
    /**
      * `Got feedback? We're all ears! Create an issue on GitHub to let us know your thoughts and suggestions`
      */
    ["com.affine.issue-feedback.description"](): string;
    /**
      * `Share Your Feedback on GitHub`
      */
    ["com.affine.issue-feedback.title"](): string;
    /**
      * `Journals`
      */
    ["com.affine.journal.app-sidebar-title"](): string;
    /**
      * `Append to Journal`
      */
    ["com.affine.journal.cmdk.append-to-today"](): string;
    /**
      * `{{count}} more articles`
      */
    ["com.affine.journal.conflict-show-more"](options: {
        readonly count: string;
    }): string;
    /**
      * `Created`
      */
    ["com.affine.journal.created-today"](): string;
    /**
      * `You haven't created anything yet`
      */
    ["com.affine.journal.daily-count-created-empty-tips"](): string;
    /**
      * `You haven't updated anything yet`
      */
    ["com.affine.journal.daily-count-updated-empty-tips"](): string;
    /**
      * `Updated`
      */
    ["com.affine.journal.updated-today"](): string;
    /**
      * `Append to Daily Note`
      */
    ["com.affine.keyboardShortcuts.appendDailyNote"](): string;
    /**
      * `Body text`
      */
    ["com.affine.keyboardShortcuts.bodyText"](): string;
    /**
      * `Bold`
      */
    ["com.affine.keyboardShortcuts.bold"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.keyboardShortcuts.cancel"](): string;
    /**
      * `Code block`
      */
    ["com.affine.keyboardShortcuts.codeBlock"](): string;
    /**
      * `Curve Connector`
      */
    ["com.affine.keyboardShortcuts.curveConnector"](): string;
    /**
      * `Divider`
      */
    ["com.affine.keyboardShortcuts.divider"](): string;
    /**
      * `Elbowed Connector`
      */
    ["com.affine.keyboardShortcuts.elbowedConnector"](): string;
    /**
      * `Expand/Collapse Sidebar`
      */
    ["com.affine.keyboardShortcuts.expandOrCollapseSidebar"](): string;
    /**
      * `Go Back`
      */
    ["com.affine.keyboardShortcuts.goBack"](): string;
    /**
      * `Go Forward`
      */
    ["com.affine.keyboardShortcuts.goForward"](): string;
    /**
      * `Group`
      */
    ["com.affine.keyboardShortcuts.group"](): string;
    /**
      * `Group as Database`
      */
    ["com.affine.keyboardShortcuts.groupDatabase"](): string;
    /**
      * `Hand`
      */
    ["com.affine.keyboardShortcuts.hand"](): string;
    /**
      * `Heading {{number}}`
      */
    ["com.affine.keyboardShortcuts.heading"](options: {
        readonly number: string;
    }): string;
    /**
      * `Image`
      */
    ["com.affine.keyboardShortcuts.image"](): string;
    /**
      * `Increase indent`
      */
    ["com.affine.keyboardShortcuts.increaseIndent"](): string;
    /**
      * `Inline code`
      */
    ["com.affine.keyboardShortcuts.inlineCode"](): string;
    /**
      * `Italic`
      */
    ["com.affine.keyboardShortcuts.italic"](): string;
    /**
      * `Hyperlink (with selected text)`
      */
    ["com.affine.keyboardShortcuts.link"](): string;
    /**
      * `Move Down`
      */
    ["com.affine.keyboardShortcuts.moveDown"](): string;
    /**
      * `Move Up`
      */
    ["com.affine.keyboardShortcuts.moveUp"](): string;
    /**
      * `New Doc`
      */
    ["com.affine.keyboardShortcuts.newPage"](): string;
    /**
      * `Note`
      */
    ["com.affine.keyboardShortcuts.note"](): string;
    /**
      * `Pen`
      */
    ["com.affine.keyboardShortcuts.pen"](): string;
    /**
      * `Quick Search`
      */
    ["com.affine.keyboardShortcuts.quickSearch"](): string;
    /**
      * `Redo`
      */
    ["com.affine.keyboardShortcuts.redo"](): string;
    /**
      * `Reduce indent`
      */
    ["com.affine.keyboardShortcuts.reduceIndent"](): string;
    /**
      * `Select`
      */
    ["com.affine.keyboardShortcuts.select"](): string;
    /**
      * `Select All`
      */
    ["com.affine.keyboardShortcuts.selectAll"](): string;
    /**
      * `Shape`
      */
    ["com.affine.keyboardShortcuts.shape"](): string;
    /**
      * `Straight Connector`
      */
    ["com.affine.keyboardShortcuts.straightConnector"](): string;
    /**
      * `Strikethrough`
      */
    ["com.affine.keyboardShortcuts.strikethrough"](): string;
    /**
      * `Check Keyboard Shortcuts quickly`
      */
    ["com.affine.keyboardShortcuts.subtitle"](): string;
    /**
      * `Switch`
      */
    ["com.affine.keyboardShortcuts.switch"](): string;
    /**
      * `Text`
      */
    ["com.affine.keyboardShortcuts.text"](): string;
    /**
      * `Keyboard shortcuts`
      */
    ["com.affine.keyboardShortcuts.title"](): string;
    /**
      * `Ungroup`
      */
    ["com.affine.keyboardShortcuts.unGroup"](): string;
    /**
      * `Underline`
      */
    ["com.affine.keyboardShortcuts.underline"](): string;
    /**
      * `Undo`
      */
    ["com.affine.keyboardShortcuts.undo"](): string;
    /**
      * `Zoom in`
      */
    ["com.affine.keyboardShortcuts.zoomIn"](): string;
    /**
      * `Zoom out`
      */
    ["com.affine.keyboardShortcuts.zoomOut"](): string;
    /**
      * `Zoom to 100%`
      */
    ["com.affine.keyboardShortcuts.zoomTo100"](): string;
    /**
      * `Zoom to fit`
      */
    ["com.affine.keyboardShortcuts.zoomToFit"](): string;
    /**
      * `Last 30 Days`
      */
    ["com.affine.last30Days"](): string;
    /**
      * `Last 7 Days`
      */
    ["com.affine.last7Days"](): string;
    /**
      * `Last month`
      */
    ["com.affine.lastMonth"](): string;
    /**
      * `Last week`
      */
    ["com.affine.lastWeek"](): string;
    /**
      * `Next week`
      */
    ["com.affine.nextWeek"](): string;
    /**
      * `Last year`
      */
    ["com.affine.lastYear"](): string;
    /**
      * `Loading...`
      */
    ["com.affine.loading"](): string;
    /**
      * `Older than a month`
      */
    ["com.affine.moreThan30Days"](): string;
    /**
      * `{{title}} will be moved to Trash`
      */
    ["com.affine.moveToTrash.confirmModal.description"](options: {
        readonly title: string;
    }): string;
    /**
      * `{{ number }} docs will be moved to Trash`
      */
    ["com.affine.moveToTrash.confirmModal.description.multiple"](options: {
        readonly number: string;
    }): string;
    /**
      * `Delete doc?`
      */
    ["com.affine.moveToTrash.confirmModal.title"](): string;
    /**
      * `Delete {{ number }} docs?`
      */
    ["com.affine.moveToTrash.confirmModal.title.multiple"](options: {
        readonly number: string;
    }): string;
    /**
      * `Move to Trash`
      */
    ["com.affine.moveToTrash.title"](): string;
    /**
      * `Enabling AFFiNE Cloud allows you to synchronise and backup data, as well as support multi-user collaboration and content publishing.`
      */
    ["com.affine.nameWorkspace.affine-cloud.description"](): string;
    /**
      * `Sync across devices with AFFiNE Cloud`
      */
    ["com.affine.nameWorkspace.affine-cloud.title"](): string;
    /**
      * `If you want the workspace to be stored locally, you can download the desktop client.`
      */
    ["com.affine.nameWorkspace.affine-cloud.web-tips"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.nameWorkspace.button.cancel"](): string;
    /**
      * `Create`
      */
    ["com.affine.nameWorkspace.button.create"](): string;
    /**
      * `A workspace is your virtual space to capture, create and plan as just one person or together as a team.`
      */
    ["com.affine.nameWorkspace.description"](): string;
    /**
      * `Set a Workspace name`
      */
    ["com.affine.nameWorkspace.placeholder"](): string;
    /**
      * `Workspace Name`
      */
    ["com.affine.nameWorkspace.subtitle.workspace-name"](): string;
    /**
      * `Name Your Workspace`
      */
    ["com.affine.nameWorkspace.title"](): string;
    /**
      * `New Page`
      */
    ["com.affine.new.page-mode"](): string;
    /**
      * `New Edgeless`
      */
    ["com.affine.new_edgeless"](): string;
    /**
      * `Import`
      */
    ["com.affine.new_import"](): string;
    /**
      * `Back Home`
      */
    ["com.affine.notFoundPage.backButton"](): string;
    /**
      * `Page Not Found`
      */
    ["com.affine.notFoundPage.title"](): string;
    /**
      * `Hyper merged whiteboard and docs`
      */
    ["com.affine.onboarding.title1"](): string;
    /**
      * `Intuitive & robust block-based editing`
      */
    ["com.affine.onboarding.title2"](): string;
    /**
      * `Easily switch between Page mode for structured document creation and Whiteboard mode for the freeform visual expression of creative ideas.`
      */
    ["com.affine.onboarding.videoDescription1"](): string;
    /**
      * `Create structured documents with ease, using a modular interface to drag and drop blocks of text, images, and other content.`
      */
    ["com.affine.onboarding.videoDescription2"](): string;
    /**
      * `A Workspace is your virtual space to capture, create and plan as just one person or together as a team.`
      */
    ["com.affine.onboarding.workspace-guide.content"](): string;
    /**
      * `Got it!`
      */
    ["com.affine.onboarding.workspace-guide.got-it"](): string;
    /**
      * `Start AFFiNE by creating your own Workspace here!`
      */
    ["com.affine.onboarding.workspace-guide.title"](): string;
    /**
      * `Open in new tab`
      */
    ["com.affine.openPageOperation.newTab"](): string;
    /**
      * `AFFiNE Community`
      */
    ["com.affine.other-page.nav.affine-community"](): string;
    /**
      * `Blog`
      */
    ["com.affine.other-page.nav.blog"](): string;
    /**
      * `Contact Us`
      */
    ["com.affine.other-page.nav.contact-us"](): string;
    /**
      * `Download App`
      */
    ["com.affine.other-page.nav.download-app"](): string;
    /**
      * `Official Website`
      */
    ["com.affine.other-page.nav.official-website"](): string;
    /**
      * `Open AFFiNE`
      */
    ["com.affine.other-page.nav.open-affine"](): string;
    /**
      * `Add linked doc`
      */
    ["com.affine.page-operation.add-linked-page"](): string;
    /**
      * `Add property`
      */
    ["com.affine.page-properties.add-property"](): string;
    /**
      * `Create property`
      */
    ["com.affine.page-properties.add-property.menu.create"](): string;
    /**
      * `Properties`
      */
    ["com.affine.page-properties.add-property.menu.header"](): string;
    /**
      * `Backlinks`
      */
    ["com.affine.page-properties.backlinks"](): string;
    /**
      * `Type`
      */
    ["com.affine.page-properties.create-property.menu.header"](): string;
    /**
      * `Icons`
      */
    ["com.affine.page-properties.icons"](): string;
    /**
      * `Info`
      */
    ["com.affine.page-properties.page-info"](): string;
    /**
      * `Empty`
      */
    ["com.affine.page-properties.property-value-placeholder"](): string;
    /**
      * `Always hide`
      */
    ["com.affine.page-properties.property.always-hide"](): string;
    /**
      * `Always show`
      */
    ["com.affine.page-properties.property.always-show"](): string;
    /**
      * `Checkbox`
      */
    ["com.affine.page-properties.property.checkbox"](): string;
    /**
      * `Date`
      */
    ["com.affine.page-properties.property.date"](): string;
    /**
      * `Hide in view`
      */
    ["com.affine.page-properties.property.hide-in-view"](): string;
    /**
      * `Hide in view when empty`
      */
    ["com.affine.page-properties.property.hide-in-view-when-empty"](): string;
    /**
      * `Hide when empty`
      */
    ["com.affine.page-properties.property.hide-when-empty"](): string;
    /**
      * `Number`
      */
    ["com.affine.page-properties.property.number"](): string;
    /**
      * `Progress`
      */
    ["com.affine.page-properties.property.progress"](): string;
    /**
      * `Remove property`
      */
    ["com.affine.page-properties.property.remove-property"](): string;
    /**
      * `Required`
      */
    ["com.affine.page-properties.property.required"](): string;
    /**
      * `Show in view`
      */
    ["com.affine.page-properties.property.show-in-view"](): string;
    /**
      * `Tags`
      */
    ["com.affine.page-properties.property.tags"](): string;
    /**
      * `Text`
      */
    ["com.affine.page-properties.property.text"](): string;
    /**
      * `customize properties`
      */
    ["com.affine.page-properties.settings.title"](): string;
    /**
      * `Open tag page`
      */
    ["com.affine.page-properties.tags.open-tags-page"](): string;
    /**
      * `Select tag or create one`
      */
    ["com.affine.page-properties.tags.selector-header-title"](): string;
    /**
      * `Display`
      */
    ["com.affine.page.display"](): string;
    /**
      * `Display properties`
      */
    ["com.affine.page.display.display-properties"](): string;
    /**
      * `Body notes`
      */
    ["com.affine.page.display.display-properties.body-notes"](): string;
    /**
      * `Grouping`
      */
    ["com.affine.page.display.grouping"](): string;
    /**
      * `Favourites`
      */
    ["com.affine.page.display.grouping.group-by-favourites"](): string;
    /**
      * `Tag`
      */
    ["com.affine.page.display.grouping.group-by-tag"](): string;
    /**
      * `Untagged`
      */
    ["com.affine.page.display.grouping.group-by-tag.untagged"](): string;
    /**
      * `No Grouping`
      */
    ["com.affine.page.display.grouping.no-grouping"](): string;
    /**
      * `List option`
      */
    ["com.affine.page.display.list-option"](): string;
    /**
      * `Clear Selection`
      */
    ["com.affine.page.group-header.clear"](): string;
    /**
      * `Favourited`
      */
    ["com.affine.page.group-header.favourited"](): string;
    /**
      * `Not Favourited`
      */
    ["com.affine.page.group-header.not-favourited"](): string;
    /**
      * `Select All`
      */
    ["com.affine.page.group-header.select-all"](): string;
    /**
      * `Doc Mode`
      */
    ["com.affine.pageMode"](): string;
    /**
      * `all`
      */
    ["com.affine.pageMode.all"](): string;
    /**
      * `Edgeless`
      */
    ["com.affine.pageMode.edgeless"](): string;
    /**
      * `Page`
      */
    ["com.affine.pageMode.page"](): string;
    /**
      * `Congratulations on your successful purchase of AFFiNE AI! You're now empowered to refine your content, generate images, and craft comprehensive mindmaps directly within AFFiNE AI, dramatically enhancing your productivity.`
      */
    ["com.affine.payment.ai-upgrade-success-page.text"](): string;
    /**
      * `Purchase Successful!`
      */
    ["com.affine.payment.ai-upgrade-success-page.title"](): string;
    /**
      * `Cancel Subscription`
      */
    ["com.affine.payment.ai.action.cancel.button-label"](): string;
    /**
      * `Keep AFFiNE AI`
      */
    ["com.affine.payment.ai.action.cancel.confirm.cancel-text"](): string;
    /**
      * `Cancel Subscription`
      */
    ["com.affine.payment.ai.action.cancel.confirm.confirm-text"](): string;
    /**
      * `If you end your subscription now, you can still use AFFiNE AI until the end of this billing period.`
      */
    ["com.affine.payment.ai.action.cancel.confirm.description"](): string;
    /**
      * `Cancel Subscription`
      */
    ["com.affine.payment.ai.action.cancel.confirm.title"](): string;
    /**
      * `Login`
      */
    ["com.affine.payment.ai.action.login.button-label"](): string;
    /**
      * `Resume`
      */
    ["com.affine.payment.ai.action.resume.button-label"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.payment.ai.action.resume.confirm.cancel-text"](): string;
    /**
      * `Confirm`
      */
    ["com.affine.payment.ai.action.resume.confirm.confirm-text"](): string;
    /**
      * `Are you sure you want to resume the subscription for AFFiNE AI? This means your payment method will be charged automatically at the end of each billing cycle, starting from the next billing cycle.`
      */
    ["com.affine.payment.ai.action.resume.confirm.description"](): string;
    /**
      * `You will be charged in the next billing cycle.`
      */
    ["com.affine.payment.ai.action.resume.confirm.notify.msg"](): string;
    /**
      * `Subscription Updated`
      */
    ["com.affine.payment.ai.action.resume.confirm.notify.title"](): string;
    /**
      * `Resume Auto-Renewal?`
      */
    ["com.affine.payment.ai.action.resume.confirm.title"](): string;
    /**
      * `Write with you`
      */
    ["com.affine.payment.ai.benefit.g1"](): string;
    /**
      * `Create quality content from sentences to articles on topics you need`
      */
    ["com.affine.payment.ai.benefit.g1-1"](): string;
    /**
      * `Rewrite like the professionals`
      */
    ["com.affine.payment.ai.benefit.g1-2"](): string;
    /**
      * `Change the tones / fix spelling & grammar`
      */
    ["com.affine.payment.ai.benefit.g1-3"](): string;
    /**
      * `Draw with you`
      */
    ["com.affine.payment.ai.benefit.g2"](): string;
    /**
      * `Visualize your mind, magically`
      */
    ["com.affine.payment.ai.benefit.g2-1"](): string;
    /**
      * `Turn your outline into beautiful, engaging presentations`
      */
    ["com.affine.payment.ai.benefit.g2-2"](): string;
    /**
      * `Summarize your content into structured mind-map`
      */
    ["com.affine.payment.ai.benefit.g2-3"](): string;
    /**
      * `Plan with you`
      */
    ["com.affine.payment.ai.benefit.g3"](): string;
    /**
      * `Memorize and tidy up your knowledge`
      */
    ["com.affine.payment.ai.benefit.g3-1"](): string;
    /**
      * `Auto-sorting and auto-tagging`
      */
    ["com.affine.payment.ai.benefit.g3-2"](): string;
    /**
      * `Open source & Privacy ensured`
      */
    ["com.affine.payment.ai.benefit.g3-3"](): string;
    /**
      * `You have purchased AFFiNE AI. The expiration date is {{end}}.`
      */
    ["com.affine.payment.ai.billing-tip.end-at"](options: {
        readonly end: string;
    }): string;
    /**
      * `You have purchased AFFiNE AI. The next payment date is {{due}}.`
      */
    ["com.affine.payment.ai.billing-tip.next-bill-at"](options: {
        readonly due: string;
    }): string;
    /**
      * `You are currently on the Basic plan.`
      */
    ["com.affine.payment.ai.pricing-plan.caption-free"](): string;
    /**
      * `You have purchased AFFiNE AI`
      */
    ["com.affine.payment.ai.pricing-plan.caption-purchased"](): string;
    /**
      * `Learn About AFFiNE AI`
      */
    ["com.affine.payment.ai.pricing-plan.learn"](): string;
    /**
      * `AFFiNE AI`
      */
    ["com.affine.payment.ai.pricing-plan.title"](): string;
    /**
      * `Turn all your ideas into reality`
      */
    ["com.affine.payment.ai.pricing-plan.title-caption-1"](): string;
    /**
      * `A true multimodal AI copilot.`
      */
    ["com.affine.payment.ai.pricing-plan.title-caption-2"](): string;
    /**
      * `You have purchased AFFiNE AI.`
      */
    ["com.affine.payment.ai.usage-description-purchased"](): string;
    /**
      * `AFFiNE AI Usage`
      */
    ["com.affine.payment.ai.usage-title"](): string;
    /**
      * `Change Plan`
      */
    ["com.affine.payment.ai.usage.change-button-label"](): string;
    /**
      * `Purchase`
      */
    ["com.affine.payment.ai.usage.purchase-button-label"](): string;
    /**
      * `Times used`
      */
    ["com.affine.payment.ai.usage.used-caption"](): string;
    /**
      * `{{used}}/{{limit}} Times`
      */
    ["com.affine.payment.ai.usage.used-detail"](options: Readonly<{
        used: string;
        limit: string;
    }>): string;
    /**
      * `Unlimited local workspaces`
      */
    ["com.affine.payment.benefit-1"](): string;
    /**
      * `Unlimited login devices`
      */
    ["com.affine.payment.benefit-2"](): string;
    /**
      * `Unlimited blocks`
      */
    ["com.affine.payment.benefit-3"](): string;
    /**
      * `{{capacity}} of Cloud Storage`
      */
    ["com.affine.payment.benefit-4"](options: {
        readonly capacity: string;
    }): string;
    /**
      * `{{capacity}} of maximum file size`
      */
    ["com.affine.payment.benefit-5"](options: {
        readonly capacity: string;
    }): string;
    /**
      * `Number of members per Workspace ≤ {{capacity}}`
      */
    ["com.affine.payment.benefit-6"](options: {
        readonly capacity: string;
    }): string;
    /**
      * `{{capacity}}-days version history`
      */
    ["com.affine.payment.benefit-7"](options: {
        readonly capacity: string;
    }): string;
    /**
      * `AFFiNE AI`
      */
    ["com.affine.payment.billing-setting.ai-plan"](): string;
    /**
      * `Purchase`
      */
    ["com.affine.payment.billing-setting.ai.purchase"](): string;
    /**
      * `Cancel Subscription`
      */
    ["com.affine.payment.billing-setting.cancel-subscription"](): string;
    /**
      * `Once you canceled subscription you will no longer enjoy the plan benefits.`
      */
    ["com.affine.payment.billing-setting.cancel-subscription.description"](): string;
    /**
      * `Change Plan`
      */
    ["com.affine.payment.billing-setting.change-plan"](): string;
    /**
      * `AFFiNE Cloud`
      */
    ["com.affine.payment.billing-setting.current-plan"](): string;
    /**
      * `Expiration Date`
      */
    ["com.affine.payment.billing-setting.expiration-date"](): string;
    /**
      * `Your subscription is valid until {{expirationDate}}`
      */
    ["com.affine.payment.billing-setting.expiration-date.description"](options: {
        readonly expirationDate: string;
    }): string;
    /**
      * `Billing history`
      */
    ["com.affine.payment.billing-setting.history"](): string;
    /**
      * `Information`
      */
    ["com.affine.payment.billing-setting.information"](): string;
    /**
      * `month`
      */
    ["com.affine.payment.billing-setting.month"](): string;
    /**
      * `There are no invoices to display.`
      */
    ["com.affine.payment.billing-setting.no-invoice"](): string;
    /**
      * `Paid`
      */
    ["com.affine.payment.billing-setting.paid"](): string;
    /**
      * `Payment Method`
      */
    ["com.affine.payment.billing-setting.payment-method"](): string;
    /**
      * `Provided by Stripe.`
      */
    ["com.affine.payment.billing-setting.payment-method.description"](): string;
    /**
      * `Renew Date`
      */
    ["com.affine.payment.billing-setting.renew-date"](): string;
    /**
      * `Next billing date: {{renewDate}}`
      */
    ["com.affine.payment.billing-setting.renew-date.description"](options: {
        readonly renewDate: string;
    }): string;
    /**
      * `Resume`
      */
    ["com.affine.payment.billing-setting.resume-subscription"](): string;
    /**
      * `Manage your billing information and invoices.`
      */
    ["com.affine.payment.billing-setting.subtitle"](): string;
    /**
      * `Billing`
      */
    ["com.affine.payment.billing-setting.title"](): string;
    /**
      * `Update`
      */
    ["com.affine.payment.billing-setting.update"](): string;
    /**
      * `Upgrade`
      */
    ["com.affine.payment.billing-setting.upgrade"](): string;
    /**
      * `View Invoice`
      */
    ["com.affine.payment.billing-setting.view-invoice"](): string;
    /**
      * `year`
      */
    ["com.affine.payment.billing-setting.year"](): string;
    /**
      * `The maximum file upload size for local workspaces is {{quota}}.`
      */
    ["com.affine.payment.blob-limit.description.local"](options: {
        readonly quota: string;
    }): string;
    /**
      * `The maximum file upload size for this joined workspace is {{quota}}. You can contact the owner of this workspace.`
      */
    ["com.affine.payment.blob-limit.description.member"](options: {
        readonly quota: string;
    }): string;
    /**
      * `{{planName}} users can upload files with a maximum size of {{currentQuota}}. You can upgrade your account to unlock a maximum file size of {{upgradeQuota}}.`
      */
    ["com.affine.payment.blob-limit.description.owner.free"](options: Readonly<{
        planName: string;
        currentQuota: string;
        upgradeQuota: string;
    }>): string;
    /**
      * `{{planName}} users can upload files with a maximum size of {{quota}}.`
      */
    ["com.affine.payment.blob-limit.description.owner.pro"](options: Readonly<{
        planName: string;
        quota: string;
    }>): string;
    /**
      * `You have reached the limit`
      */
    ["com.affine.payment.blob-limit.title"](): string;
    /**
      * `Book a Demo`
      */
    ["com.affine.payment.book-a-demo"](): string;
    /**
      * `Buy Pro`
      */
    ["com.affine.payment.buy-pro"](): string;
    /**
      * `Change to {{to}} Billing`
      */
    ["com.affine.payment.change-to"](options: {
        readonly to: string;
    }): string;
    /**
      * `Include in FOSS`
      */
    ["com.affine.payment.cloud.free.benefit.g1"](): string;
    /**
      * `Unlimited Local Workspaces`
      */
    ["com.affine.payment.cloud.free.benefit.g1-1"](): string;
    /**
      * `Unlimited use and Customization`
      */
    ["com.affine.payment.cloud.free.benefit.g1-2"](): string;
    /**
      * `Unlimited Doc and Edgeless editing`
      */
    ["com.affine.payment.cloud.free.benefit.g1-3"](): string;
    /**
      * `Include in Basic`
      */
    ["com.affine.payment.cloud.free.benefit.g2"](): string;
    /**
      * `10 GB of Cloud Storage.`
      */
    ["com.affine.payment.cloud.free.benefit.g2-1"](): string;
    /**
      * `10 MB of Maximum file size.`
      */
    ["com.affine.payment.cloud.free.benefit.g2-2"](): string;
    /**
      * `Up to 3 members per Workspace.`
      */
    ["com.affine.payment.cloud.free.benefit.g2-3"](): string;
    /**
      * `7-days Cloud Time Machine file version history.`
      */
    ["com.affine.payment.cloud.free.benefit.g2-4"](): string;
    /**
      * `Up to 3 login devices.`
      */
    ["com.affine.payment.cloud.free.benefit.g2-5"](): string;
    /**
      * `Open-Source under MIT license.`
      */
    ["com.affine.payment.cloud.free.description"](): string;
    /**
      * `FOSS + Basic`
      */
    ["com.affine.payment.cloud.free.name"](): string;
    /**
      * `Free forever`
      */
    ["com.affine.payment.cloud.free.title"](): string;
    /**
      * `We host, no technical setup required.`
      */
    ["com.affine.payment.cloud.pricing-plan.select.caption"](): string;
    /**
      * `Hosted by AFFiNE.Pro`
      */
    ["com.affine.payment.cloud.pricing-plan.select.title"](): string;
    /**
      * `Billed Yearly`
      */
    ["com.affine.payment.cloud.pricing-plan.toggle-billed-yearly"](): string;
    /**
      * `Saving {{discount}}%`
      */
    ["com.affine.payment.cloud.pricing-plan.toggle-discount"](options: {
        readonly discount: string;
    }): string;
    /**
      * `Yearly`
      */
    ["com.affine.payment.cloud.pricing-plan.toggle-yearly"](): string;
    /**
      * `Include in Pro`
      */
    ["com.affine.payment.cloud.pro.benefit.g1"](): string;
    /**
      * `Everything in AFFiNE FOSS & Basic.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-1"](): string;
    /**
      * `100 GB of Cloud Storage.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-2"](): string;
    /**
      * `100 MB of Maximum file size.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-3"](): string;
    /**
      * `Up to 10 members per Workspace.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-4"](): string;
    /**
      * `30-days Cloud Time Machine file version history.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-5"](): string;
    /**
      * `Add comments on Doc and Edgeless.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-6"](): string;
    /**
      * `Community Support.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-7"](): string;
    /**
      * `Real-time Syncing & Collaboration for more people.`
      */
    ["com.affine.payment.cloud.pro.benefit.g1-8"](): string;
    /**
      * `For family and small teams.`
      */
    ["com.affine.payment.cloud.pro.description"](): string;
    /**
      * `Pro`
      */
    ["com.affine.payment.cloud.pro.name"](): string;
    /**
      * `billed yearly`
      */
    ["com.affine.payment.cloud.pro.title.billed-yearly"](): string;
    /**
      * `{{price}} per month`
      */
    ["com.affine.payment.cloud.pro.title.price-monthly"](options: {
        readonly price: string;
    }): string;
    /**
      * `Both in Team & Enterprise`
      */
    ["com.affine.payment.cloud.team.benefit.g1"](): string;
    /**
      * `Everything in AFFiNE Pro.`
      */
    ["com.affine.payment.cloud.team.benefit.g1-1"](): string;
    /**
      * `Advanced Permission control, Page history and Review mode.`
      */
    ["com.affine.payment.cloud.team.benefit.g1-2"](): string;
    /**
      * `Pay for seats, fits all team size.`
      */
    ["com.affine.payment.cloud.team.benefit.g1-3"](): string;
    /**
      * `Email & Slack Support.`
      */
    ["com.affine.payment.cloud.team.benefit.g1-4"](): string;
    /**
      * `Enterprise only`
      */
    ["com.affine.payment.cloud.team.benefit.g2"](): string;
    /**
      * `SSO Authorization.`
      */
    ["com.affine.payment.cloud.team.benefit.g2-1"](): string;
    /**
      * `Solutions & Best Practices for Dedicated needs.`
      */
    ["com.affine.payment.cloud.team.benefit.g2-2"](): string;
    /**
      * `Embed-able & Integrations with IT support.`
      */
    ["com.affine.payment.cloud.team.benefit.g2-3"](): string;
    /**
      * `Best for scalable teams.`
      */
    ["com.affine.payment.cloud.team.description"](): string;
    /**
      * `Team / Enterprise`
      */
    ["com.affine.payment.cloud.team.name"](): string;
    /**
      * `Contact Sales`
      */
    ["com.affine.payment.cloud.team.title"](): string;
    /**
      * `Contact Sales`
      */
    ["com.affine.payment.contact-sales"](): string;
    /**
      * `Current Plan`
      */
    ["com.affine.payment.current-plan"](): string;
    /**
      * `This is a special testing(Canary) version of AFFiNE. Account upgrades are not supported in this version. If you want to experience the full service, please download the stable version from our website.`
      */
    ["com.affine.payment.disable-payment.description"](): string;
    /**
      * `Account Upgrade Unavailable`
      */
    ["com.affine.payment.disable-payment.title"](): string;
    /**
      * `{{amount}}% off`
      */
    ["com.affine.payment.discount-amount"](options: {
        readonly amount: string;
    }): string;
    /**
      * `Downgrade`
      */
    ["com.affine.payment.downgrade"](): string;
    /**
      * `You have successfully downgraded. After the current billing period ends, your account will automatically switch to the Free plan.`
      */
    ["com.affine.payment.downgraded-tooltip"](): string;
    /**
      * `Best team workspace for collaboration and knowledge distilling.`
      */
    ["com.affine.payment.dynamic-benefit-1"](): string;
    /**
      * `Focusing on what really matters with team project management and automation.`
      */
    ["com.affine.payment.dynamic-benefit-2"](): string;
    /**
      * `Pay for seats, fits all team size.`
      */
    ["com.affine.payment.dynamic-benefit-3"](): string;
    /**
      * `Solutions & best practices for dedicated needs.`
      */
    ["com.affine.payment.dynamic-benefit-4"](): string;
    /**
      * `Embedable & interrogations with IT support.`
      */
    ["com.affine.payment.dynamic-benefit-5"](): string;
    /**
      * `Upgrade`
      */
    ["com.affine.payment.member-limit.free.confirm"](): string;
    /**
      * `Each {{planName}} user can invite up to {{quota}} members to join their workspace. You can upgrade your account to unlock more members.`
      */
    ["com.affine.payment.member-limit.free.description"](options: Readonly<{
        planName: string;
        quota: string;
    }>): string;
    /**
      * `Got it`
      */
    ["com.affine.payment.member-limit.pro.confirm"](): string;
    /**
      * `Each {{planName}} user can invite up to {{quota}} members to join their workspace. If you want to continue adding collaboration members, you can create a new workspace.`
      */
    ["com.affine.payment.member-limit.pro.description"](options: Readonly<{
        planName: string;
        quota: string;
    }>): string;
    /**
      * `You have reached the limit`
      */
    ["com.affine.payment.member-limit.title"](): string;
    /**
      * `Manage members here. {{planName}} Users can invite up to {{memberLimit}}`
      */
    ["com.affine.payment.member.description"](options: Readonly<{
        planName: string;
        memberLimit: string;
    }>): string;
    /**
      * `Choose your plan`
      */
    ["com.affine.payment.member.description.choose-plan"](): string;
    /**
      * `go upgrade`
      */
    ["com.affine.payment.member.description.go-upgrade"](): string;
    /**
      * `Looking to collaborate with more people?`
      */
    ["com.affine.payment.member.description2"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.payment.modal.change.cancel"](): string;
    /**
      * `Change`
      */
    ["com.affine.payment.modal.change.confirm"](): string;
    /**
      * `Change your subscription`
      */
    ["com.affine.payment.modal.change.title"](): string;
    /**
      * `Cancel Subscription`
      */
    ["com.affine.payment.modal.downgrade.cancel"](): string;
    /**
      * `You can still use AFFiNE Cloud Pro until the end of this billing period :)`
      */
    ["com.affine.payment.modal.downgrade.caption"](): string;
    /**
      * `Keep AFFiNE Cloud Pro`
      */
    ["com.affine.payment.modal.downgrade.confirm"](): string;
    /**
      * `We're sorry to see you go, but we're always working to improve, and your feedback is welcome. We hope to see you return in the future.`
      */
    ["com.affine.payment.modal.downgrade.content"](): string;
    /**
      * `Are you sure?`
      */
    ["com.affine.payment.modal.downgrade.title"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.payment.modal.resume.cancel"](): string;
    /**
      * `Confirm`
      */
    ["com.affine.payment.modal.resume.confirm"](): string;
    /**
      * `Are you sure you want to resume the subscription for your pro account? This means your payment method will be charged automatically at the end of each billing cycle, starting from the next billing cycle.`
      */
    ["com.affine.payment.modal.resume.content"](): string;
    /**
      * `Resume Auto-Renewal?`
      */
    ["com.affine.payment.modal.resume.title"](): string;
    /**
      * `Refresh`
      */
    ["com.affine.payment.plans-error-retry"](): string;
    /**
      * `Unable to load Pricing plans, please check your network. `
      */
    ["com.affine.payment.plans-error-tip"](): string;
    /**
      * `per month`
      */
    ["com.affine.payment.price-description.per-month"](): string;
    /**
      * `monthly`
      */
    ["com.affine.payment.recurring-monthly"](): string;
    /**
      * `yearly`
      */
    ["com.affine.payment.recurring-yearly"](): string;
    /**
      * `Resume`
      */
    ["com.affine.payment.resume"](): string;
    /**
      * `Resume Auto-renewal`
      */
    ["com.affine.payment.resume-renewal"](): string;
    /**
      * `See all plans`
      */
    ["com.affine.payment.see-all-plans"](): string;
    /**
      * `Sign up free`
      */
    ["com.affine.payment.sign-up-free"](): string;
    /**
      * `Cloud storage is insufficient. Please contact the owner of that workspace.`
      */
    ["com.affine.payment.storage-limit.description.member"](): string;
    /**
      * `Cloud storage is insufficient. You can upgrade your account to unlock more cloud storage.`
      */
    ["com.affine.payment.storage-limit.description.owner"](): string;
    /**
      * `Sync failed`
      */
    ["com.affine.payment.storage-limit.title"](): string;
    /**
      * `View`
      */
    ["com.affine.payment.storage-limit.view"](): string;
    /**
      * `You already have a subscription.`
      */
    ["com.affine.payment.subscription.exist"](): string;
    /**
      * `Subscribe AFFiNE`
      */
    ["com.affine.payment.subscription.go-to-subscribe"](): string;
    /**
      * `You are currently on the {{plan}} plan. After the current billing period ends, your account will automatically switch to the Free plan.`
      */
    ["com.affine.payment.subtitle-canceled"](options: {
        readonly plan: string;
    }): string;
    /**
      * `This is the Pricing plans of AFFiNE Cloud. You can sign up or sign in to your account first.`
      */
    ["com.affine.payment.subtitle-not-signed-in"](): string;
    /**
      * `See all plans`
      */
    ["com.affine.payment.tag-tooltips"](): string;
    /**
      * `Pricing Plans`
      */
    ["com.affine.payment.title"](): string;
    /**
      * `You have changed your plan to {{plan}} billing.`
      */
    ["com.affine.payment.updated-notify-msg"](options: {
        readonly plan: string;
    }): string;
    /**
      * `No further charges will be made starting from the next billing cycle.`
      */
    ["com.affine.payment.updated-notify-msg.cancel-subscription"](): string;
    /**
      * `Subscription updated`
      */
    ["com.affine.payment.updated-notify-title"](): string;
    /**
      * `Upgrade`
      */
    ["com.affine.payment.upgrade"](): string;
    /**
      * `Congratulations! Your AFFiNE account has been successfully upgraded to a Pro account.`
      */
    ["com.affine.payment.upgrade-success-page.text"](): string;
    /**
      * `Upgrade Successful!`
      */
    ["com.affine.payment.upgrade-success-page.title"](): string;
    /**
      * `Meet AFFiNE AI`
      */
    ["com.affine.ai-scroll-tip.title"](): string;
    /**
      * `New`
      */
    ["com.affine.ai-scroll-tip.tag"](): string;
    /**
      * `View`
      */
    ["com.affine.ai-scroll-tip.view"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.publicLinkDisableModal.button.cancel"](): string;
    /**
      * `Disable`
      */
    ["com.affine.publicLinkDisableModal.button.disable"](): string;
    /**
      * `Disabling this public link will prevent anyone with the link from accessing this doc.`
      */
    ["com.affine.publicLinkDisableModal.description"](): string;
    /**
      * `Disable Public Link`
      */
    ["com.affine.publicLinkDisableModal.title"](): string;
    /**
      * `Reset Sync`
      */
    ["com.affine.resetSyncStatus.button"](): string;
    /**
      * `This operation may fix some synchronization issues.`
      */
    ["com.affine.resetSyncStatus.description"](): string;
    /**
      * `Collections`
      */
    ["com.affine.rootAppSidebar.collections"](): string;
    /**
      * `Favourites`
      */
    ["com.affine.rootAppSidebar.favorites"](): string;
    /**
      * `You can add documents to your favourites`
      */
    ["com.affine.rootAppSidebar.favorites.empty"](): string;
    /**
      * `Others`
      */
    ["com.affine.rootAppSidebar.others"](): string;
    /**
      * `Type here ...`
      */
    ["com.affine.search-tags.placeholder"](): string;
    /**
      * `Empty`
      */
    ["com.affine.selectPage.empty"](): string;
    /**
      * `Selected`
      */
    ["com.affine.selectPage.selected"](): string;
    /**
      * `Add include doc`
      */
    ["com.affine.selectPage.title"](): string;
    /**
      * `Customise`
      */
    ["com.affine.setDBLocation.button.customize"](): string;
    /**
      * `Default Location`
      */
    ["com.affine.setDBLocation.button.defaultLocation"](): string;
    /**
      * `Select where you want to create your workspace. The data of workspace is saved locally by default.`
      */
    ["com.affine.setDBLocation.description"](): string;
    /**
      * `Set database location`
      */
    ["com.affine.setDBLocation.title"](): string;
    /**
      * `By default will be saved to {{location}}`
      */
    ["com.affine.setDBLocation.tooltip.defaultLocation"](options: {
        readonly location: string;
    }): string;
    /**
      * `Continue`
      */
    ["com.affine.setSyncingMode.button.continue"](): string;
    /**
      * `Sync across devices with AFFiNE Cloud`
      */
    ["com.affine.setSyncingMode.cloud"](): string;
    /**
      * `Use on current device only`
      */
    ["com.affine.setSyncingMode.deviceOnly"](): string;
    /**
      * `Added Successfully`
      */
    ["com.affine.setSyncingMode.title.added"](): string;
    /**
      * `Created Successfully`
      */
    ["com.affine.setSyncingMode.title.created"](): string;
    /**
      * `Account Settings`
      */
    ["com.affine.setting.account"](): string;
    /**
      * `Delete Account`
      */
    ["com.affine.setting.account.delete"](): string;
    /**
      * `Permanently delete this account and the Workspace data backup in AFFiNE Cloud. This action can not be undone.`
      */
    ["com.affine.setting.account.delete.message"](): string;
    /**
      * `Your personal information`
      */
    ["com.affine.setting.account.message"](): string;
    /**
      * `Sync with AFFiNE Cloud`
      */
    ["com.affine.setting.sign.message"](): string;
    /**
      * `Securely sign out of your account.`
      */
    ["com.affine.setting.sign.out.message"](): string;
    /**
      * `General`
      */
    ["com.affine.settingSidebar.settings.general"](): string;
    /**
      * `Workspace`
      */
    ["com.affine.settingSidebar.settings.workspace"](): string;
    /**
      * `Settings`
      */
    ["com.affine.settingSidebar.title"](): string;
    /**
      * `Information about AFFiNE`
      */
    ["com.affine.settings.about.message"](): string;
    /**
      * `Automatically check for new updates periodically.`
      */
    ["com.affine.settings.about.update.check.message"](): string;
    /**
      * `Automatically download updates (to this device).`
      */
    ["com.affine.settings.about.update.download.message"](): string;
    /**
      * `Appearance`
      */
    ["com.affine.settings.appearance"](): string;
    /**
      * `Customise the appearance of the client.`
      */
    ["com.affine.settings.appearance.border-style-description"](): string;
    /**
      * `Customise your date style.`
      */
    ["com.affine.settings.appearance.date-format-description"](): string;
    /**
      * `Maximum display of content within a doc.`
      */
    ["com.affine.settings.appearance.full-width-description"](): string;
    /**
      * `Select the language for the interface.`
      */
    ["com.affine.settings.appearance.language-description"](): string;
    /**
      * `By default, the week starts on Sunday.`
      */
    ["com.affine.settings.appearance.start-week-description"](): string;
    /**
      * `Customise appearance of Windows Client.`
      */
    ["com.affine.settings.appearance.window-frame-description"](): string;
    /**
      * `If enabled, it will automatically check for new versions at regular intervals.`
      */
    ["com.affine.settings.auto-check-description"](): string;
    /**
      * ` If enabled, new versions will be automatically downloaded to the current device.`
      */
    ["com.affine.settings.auto-download-description"](): string;
    /**
      * `Email`
      */
    ["com.affine.settings.email"](): string;
    /**
      * `Change Email`
      */
    ["com.affine.settings.email.action"](): string;
    /**
      * `Change Email`
      */
    ["com.affine.settings.email.action.change"](): string;
    /**
      * `Verify Email`
      */
    ["com.affine.settings.email.action.verify"](): string;
    /**
      * `Enable AFFiNE Cloud to collaborate with others`
      */
    ["com.affine.settings.member-tooltip"](): string;
    /**
      * `Loading member list...`
      */
    ["com.affine.settings.member.loading"](): string;
    /**
      * `Noise background on the sidebar`
      */
    ["com.affine.settings.noise-style"](): string;
    /**
      * `Use background noise effect on the sidebar.`
      */
    ["com.affine.settings.noise-style-description"](): string;
    /**
      * `Password`
      */
    ["com.affine.settings.password"](): string;
    /**
      * `Change password`
      */
    ["com.affine.settings.password.action.change"](): string;
    /**
      * `Set password`
      */
    ["com.affine.settings.password.action.set"](): string;
    /**
      * `Set a password to sign in to your account`
      */
    ["com.affine.settings.password.message"](): string;
    /**
      * `My Profile`
      */
    ["com.affine.settings.profile"](): string;
    /**
      * `Your account profile will be displayed to everyone.`
      */
    ["com.affine.settings.profile.message"](): string;
    /**
      * `Display Name`
      */
    ["com.affine.settings.profile.name"](): string;
    /**
      * `Input account name`
      */
    ["com.affine.settings.profile.placeholder"](): string;
    /**
      * `Remove Workspace`
      */
    ["com.affine.settings.remove-workspace"](): string;
    /**
      * `Remove Workspace from this device and optionally delete all data.`
      */
    ["com.affine.settings.remove-workspace-description"](): string;
    /**
      * `Sign in / Sign up`
      */
    ["com.affine.settings.sign"](): string;
    /**
      * `Click to move storage location.`
      */
    ["com.affine.settings.storage.db-location.change-hint"](): string;
    /**
      * `Check or change storage location`
      */
    ["com.affine.settings.storage.description"](): string;
    /**
      * `Check or change storage location. Click path to edit location.`
      */
    ["com.affine.settings.storage.description-alt"](): string;
    /**
      * `Need more customization options? Tell us in the community.`
      */
    ["com.affine.settings.suggestion"](): string;
    /**
      * `Translucent UI on the sidebar`
      */
    ["com.affine.settings.translucent-style"](): string;
    /**
      * `Use transparency effect on the sidebar.`
      */
    ["com.affine.settings.translucent-style-description"](): string;
    /**
      * `Workspace`
      */
    ["com.affine.settings.workspace"](): string;
    /**
      * `You can view current workspace's information here.`
      */
    ["com.affine.settings.workspace.description"](): string;
    /**
      * `Experimental Features`
      */
    ["com.affine.settings.workspace.experimental-features"](): string;
    /**
      * `Get Started`
      */
    ["com.affine.settings.workspace.experimental-features.get-started"](): string;
    /**
      * `Experimental Features`
      */
    ["com.affine.settings.workspace.experimental-features.header.plugins"](): string;
    /**
      * `I am aware of the risks, and I am willing to continue to use it.`
      */
    ["com.affine.settings.workspace.experimental-features.prompt-disclaimer"](): string;
    /**
      * `Do you want to use the plugin system that is in an experimental stage?`
      */
    ["com.affine.settings.workspace.experimental-features.prompt-header"](): string;
    /**
      * `You are about to enable an experimental feature. This feature is still in development and may contain errors or behave unpredictably. Please proceed with caution and at your own risk.`
      */
    ["com.affine.settings.workspace.experimental-features.prompt-warning"](): string;
    /**
      * `WARNING MESSAGE`
      */
    ["com.affine.settings.workspace.experimental-features.prompt-warning-title"](): string;
    /**
      * `Only an owner can edit the the Workspace avatar and name.Changes will be shown for everyone.`
      */
    ["com.affine.settings.workspace.not-owner"](): string;
    /**
      * `Preference`
      */
    ["com.affine.settings.workspace.preferences"](): string;
    /**
      * `Properties`
      */
    ["com.affine.settings.workspace.properties"](): string;
    /**
      * `Add property`
      */
    ["com.affine.settings.workspace.properties.add_property"](): string;
    /**
      * `All`
      */
    ["com.affine.settings.workspace.properties.all"](): string;
    /**
      * `Delete property`
      */
    ["com.affine.settings.workspace.properties.delete-property"](): string;
    /**
      * `Edit property`
      */
    ["com.affine.settings.workspace.properties.edit-property"](): string;
    /**
      * `General properties`
      */
    ["com.affine.settings.workspace.properties.general-properties"](): string;
    /**
      * `Properties`
      */
    ["com.affine.settings.workspace.properties.header.title"](): string;
    /**
      * `In use`
      */
    ["com.affine.settings.workspace.properties.in-use"](): string;
    /**
      * `Required properties`
      */
    ["com.affine.settings.workspace.properties.required-properties"](): string;
    /**
      * `Set as required property`
      */
    ["com.affine.settings.workspace.properties.set-as-required"](): string;
    /**
      * `Unused`
      */
    ["com.affine.settings.workspace.properties.unused"](): string;
    /**
      * `Enable AFFiNE Cloud to publish this Workspace`
      */
    ["com.affine.settings.workspace.publish-tooltip"](): string;
    /**
      * `Click to move storage location.`
      */
    ["com.affine.settings.workspace.storage.tip"](): string;
    /**
      * `Sharing doc requires AFFiNE Cloud.`
      */
    ["com.affine.share-menu.EnableCloudDescription"](): string;
    /**
      * `Share mode`
      */
    ["com.affine.share-menu.ShareMode"](): string;
    /**
      * `Share Doc`
      */
    ["com.affine.share-menu.SharePage"](): string;
    /**
      * `Share via Export`
      */
    ["com.affine.share-menu.ShareViaExport"](): string;
    /**
      * `Download a static copy of your doc to share with others.`
      */
    ["com.affine.share-menu.ShareViaExportDescription"](): string;
    /**
      * `Share with link`
      */
    ["com.affine.share-menu.ShareWithLink"](): string;
    /**
      * `Create a link you can easily share with anyone. The visitors will open your doc in the form od a document`
      */
    ["com.affine.share-menu.ShareWithLinkDescription"](): string;
    /**
      * `Shared Doc`
      */
    ["com.affine.share-menu.SharedPage"](): string;
    /**
      * `Please try again later.`
      */
    ["com.affine.share-menu.confirm-modify-mode.notification.fail.message"](): string;
    /**
      * `Failed to modify`
      */
    ["com.affine.share-menu.confirm-modify-mode.notification.fail.title"](): string;
    /**
      * `You have changed the public link from {{preMode}} Mode to {{currentMode}} Mode.`
      */
    ["com.affine.share-menu.confirm-modify-mode.notification.success.message"](options: Readonly<{
        preMode: string;
        currentMode: string;
    }>): string;
    /**
      * `Modified successfully`
      */
    ["com.affine.share-menu.confirm-modify-mode.notification.success.title"](): string;
    /**
      * `Copy Private Link`
      */
    ["com.affine.share-menu.copy-private-link"](): string;
    /**
      * `Please try again later.`
      */
    ["com.affine.share-menu.create-public-link.notification.fail.message"](): string;
    /**
      * `Failed to create public link`
      */
    ["com.affine.share-menu.create-public-link.notification.fail.title"](): string;
    /**
      * `You can share this document with link.`
      */
    ["com.affine.share-menu.create-public-link.notification.success.message"](): string;
    /**
      * `Public link created`
      */
    ["com.affine.share-menu.create-public-link.notification.success.title"](): string;
    /**
      * `Please try again later.`
      */
    ["com.affine.share-menu.disable-publish-link.notification.fail.message"](): string;
    /**
      * `Failed to disable public link`
      */
    ["com.affine.share-menu.disable-publish-link.notification.fail.title"](): string;
    /**
      * `This doc is no longer shared publicly.`
      */
    ["com.affine.share-menu.disable-publish-link.notification.success.message"](): string;
    /**
      * `Public link disabled`
      */
    ["com.affine.share-menu.disable-publish-link.notification.success.title"](): string;
    /**
      * `Publish to Web`
      */
    ["com.affine.share-menu.publish-to-web"](): string;
    /**
      * `Let anyone with a link view a read-only version of this doc.`
      */
    ["com.affine.share-menu.publish-to-web.description"](): string;
    /**
      * `Share Privately`
      */
    ["com.affine.share-menu.share-privately"](): string;
    /**
      * `Only members of this Workspace can open this link.`
      */
    ["com.affine.share-menu.share-privately.description"](): string;
    /**
      * `Share`
      */
    ["com.affine.share-menu.shareButton"](): string;
    /**
      * `Shared`
      */
    ["com.affine.share-menu.sharedButton"](): string;
    /**
      * `Built with`
      */
    ["com.affine.share-page.footer.built-with"](): string;
    /**
      * `Create with`
      */
    ["com.affine.share-page.footer.create-with"](): string;
    /**
      * `Empower your sharing with AffiNE Cloud: One-click doc sharing`
      */
    ["com.affine.share-page.footer.description"](): string;
    /**
      * `Get started for free`
      */
    ["com.affine.share-page.footer.get-started"](): string;
    /**
      * `Present`
      */
    ["com.affine.share-page.header.present"](): string;
    /**
      * `Edgeless`
      */
    ["com.affine.shortcutsTitle.edgeless"](): string;
    /**
      * `General`
      */
    ["com.affine.shortcutsTitle.general"](): string;
    /**
      * `Markdown Syntax`
      */
    ["com.affine.shortcutsTitle.markdownSyntax"](): string;
    /**
      * `Page`
      */
    ["com.affine.shortcutsTitle.page"](): string;
    /**
      * `Collapse sidebar`
      */
    ["com.affine.sidebarSwitch.collapse"](): string;
    /**
      * `Expand sidebar`
      */
    ["com.affine.sidebarSwitch.expand"](): string;
    /**
      * `Maybe Later`
      */
    ["com.affine.star-affine.cancel"](): string;
    /**
      * `Star on GitHub`
      */
    ["com.affine.star-affine.confirm"](): string;
    /**
      * `Are you finding our app useful and enjoyable? We'd love your support to keep improving! A great way to help us out is by giving us a star on GitHub. This simple action can make a big difference and helps us continue to deliver the best experience for you.`
      */
    ["com.affine.star-affine.description"](): string;
    /**
      * `Star Us on GitHub`
      */
    ["com.affine.star-affine.title"](): string;
    /**
      * `Change Plan`
      */
    ["com.affine.storage.change-plan"](): string;
    /**
      * `AFFiNE Cloud is currently in early access phase and is not supported for upgrading, please be patient and wait for our pricing plan.`
      */
    ["com.affine.storage.disabled.hint"](): string;
    /**
      * `The usage has reached its maximum capacity, AFFiNE Cloud is currently in early access phase and is not supported for upgrading, please be patient and wait for our pricing plan. `
      */
    ["com.affine.storage.extend.hint"](): string;
    /**
      * `To get more information click here.`
      */
    ["com.affine.storage.extend.link"](): string;
    /**
      * `You have reached the maximum capacity limit for your current account`
      */
    ["com.affine.storage.maximum-tips"](): string;
    /**
      * `Pro users will have unlimited storage capacity during the alpha test period of the team version`
      */
    ["com.affine.storage.maximum-tips.pro"](): string;
    /**
      * `Plan`
      */
    ["com.affine.storage.plan"](): string;
    /**
      * `AFFiNE Cloud Storage`
      */
    ["com.affine.storage.title"](): string;
    /**
      * `Upgrade`
      */
    ["com.affine.storage.upgrade"](): string;
    /**
      * `Space used`
      */
    ["com.affine.storage.used.hint"](): string;
    /**
      * `{{count}} doc`
    
      * - com.affine.tags.count_one: `{{count}} doc`
    
      * - com.affine.tags.count_other: `{{count}} docs`
    
      * - com.affine.tags.count_zero: `{{count}} doc`
      */
    ["com.affine.tags.count"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `{{count}} doc`
      */
    ["com.affine.tags.count_one"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `{{count}} docs`
      */
    ["com.affine.tags.count_other"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `{{count}} doc`
      */
    ["com.affine.tags.count_zero"](options: {
        readonly count: string | number | bigint;
    }): string;
    /**
      * `Type tag name here...`
      */
    ["com.affine.tags.create-tag.placeholder"](): string;
    /**
      * `Tag already exists`
      */
    ["com.affine.tags.create-tag.toast.exist"](): string;
    /**
      * `Tag created`
      */
    ["com.affine.tags.create-tag.toast.success"](): string;
    /**
      * `Tag deleted`
      */
    ["com.affine.tags.delete-tags.toast"](): string;
    /**
      * `Tag updated`
      */
    ["com.affine.tags.edit-tag.toast.success"](): string;
    /**
      * `New Tag`
      */
    ["com.affine.tags.empty.new-tag-button"](): string;
    /**
      * `Enable Telemetry`
      */
    ["com.affine.telemetry.enable"](): string;
    /**
      * `Telemetry is a feature that allows us to collect data on how you use the app. This data helps us improve the app and provide better features.`
      */
    ["com.affine.telemetry.enable.desc"](): string;
    /**
      * `Dark`
      */
    ["com.affine.themeSettings.dark"](): string;
    /**
      * `Light`
      */
    ["com.affine.themeSettings.light"](): string;
    /**
      * `System`
      */
    ["com.affine.themeSettings.system"](): string;
    /**
      * `Successfully added linked doc`
      */
    ["com.affine.toastMessage.addLinkedPage"](): string;
    /**
      * `Added to Favourites`
      */
    ["com.affine.toastMessage.addedFavorites"](): string;
    /**
      * `Edgeless Mode`
      */
    ["com.affine.toastMessage.edgelessMode"](): string;
    /**
      * `Moved to Trash`
      */
    ["com.affine.toastMessage.movedTrash"](): string;
    /**
      * `Page Mode`
      */
    ["com.affine.toastMessage.pageMode"](): string;
    /**
      * `Permanently deleted`
      */
    ["com.affine.toastMessage.permanentlyDeleted"](): string;
    /**
      * `Removed from Favourites`
      */
    ["com.affine.toastMessage.removedFavorites"](): string;
    /**
      * `Successfully renamed`
      */
    ["com.affine.toastMessage.rename"](): string;
    /**
      * `{{title}} restored`
      */
    ["com.affine.toastMessage.restored"](options: {
        readonly title: string;
    }): string;
    /**
      * `Successfully deleted`
      */
    ["com.affine.toastMessage.successfullyDeleted"](): string;
    /**
      * `Today`
      */
    ["com.affine.today"](): string;
    /**
      * `Tomorrow`
      */
    ["com.affine.tomorrow"](): string;
    /**
      * `Delete`
      */
    ["com.affine.trashOperation.delete"](): string;
    /**
      * `Once deleted, you can't undo this action. Do you confirm?`
      */
    ["com.affine.trashOperation.delete.description"](): string;
    /**
      * `Permanently delete`
      */
    ["com.affine.trashOperation.delete.title"](): string;
    /**
      * `Once deleted, you can't undo this action. Do you confirm?`
      */
    ["com.affine.trashOperation.deleteDescription"](): string;
    /**
      * `Delete permanently`
      */
    ["com.affine.trashOperation.deletePermanently"](): string;
    /**
      * `Restore it`
      */
    ["com.affine.trashOperation.restoreIt"](): string;
    /**
      * `Downloading`
      */
    ["com.affine.updater.downloading"](): string;
    /**
      * `Open download page`
      */
    ["com.affine.updater.open-download-page"](): string;
    /**
      * `Restart to install update`
      */
    ["com.affine.updater.restart-to-update"](): string;
    /**
      * `Update available`
      */
    ["com.affine.updater.update-available"](): string;
    /**
      * `Refresh Current Page`
      */
    ["com.affine.upgrade.button-text.done"](): string;
    /**
      * `Data Upgrade Error`
      */
    ["com.affine.upgrade.button-text.error"](): string;
    /**
      * `Upgrade Workspace Data`
      */
    ["com.affine.upgrade.button-text.pending"](): string;
    /**
      * `Upgrading`
      */
    ["com.affine.upgrade.button-text.upgrading"](): string;
    /**
      * `After upgrading the workspace data, please refresh the page to see the changes.`
      */
    ["com.affine.upgrade.tips.done"](): string;
    /**
      * `We encountered some errors while upgrading the workspace data.`
      */
    ["com.affine.upgrade.tips.error"](): string;
    /**
      * `To ensure compatibility with the updated AFFiNE client, please upgrade your data by clicking the "Upgrade Workspace Data" button below.`
      */
    ["com.affine.upgrade.tips.normal"](): string;
    /**
      * `Close`
      */
    ["com.affine.workbench.split-view-menu.close"](): string;
    /**
      * `Full Screen`
      */
    ["com.affine.workbench.split-view-menu.full-screen"](): string;
    /**
      * `Solo View`
      */
    ["com.affine.workbench.split-view-menu.keep-this-one"](): string;
    /**
      * `Move Left`
      */
    ["com.affine.workbench.split-view-menu.move-left"](): string;
    /**
      * `Move Right`
      */
    ["com.affine.workbench.split-view-menu.move-right"](): string;
    /**
      * `Open in split view`
      */
    ["com.affine.workbench.split-view.page-menu-open"](): string;
    /**
      * `You cannot delete the last workspace`
      */
    ["com.affine.workspace.cannot-delete"](): string;
    /**
      * `Cloud Workspaces`
      */
    ["com.affine.workspace.cloud"](): string;
    /**
      * `Sign Out`
      */
    ["com.affine.workspace.cloud.account.logout"](): string;
    /**
      * `Account Settings`
      */
    ["com.affine.workspace.cloud.account.settings"](): string;
    /**
      * `Sign up/ Sign in`
      */
    ["com.affine.workspace.cloud.auth"](): string;
    /**
      * `Sync with AFFiNE Cloud`
      */
    ["com.affine.workspace.cloud.description"](): string;
    /**
      * `Join Workspace`
      */
    ["com.affine.workspace.cloud.join"](): string;
    /**
      * `Cloud sync`
      */
    ["com.affine.workspace.cloud.sync"](): string;
    /**
      * `Failed to enable Cloud, please try again.`
      */
    ["com.affine.workspace.enable-cloud.failed"](): string;
    /**
      * `Local Workspaces`
      */
    ["com.affine.workspace.local"](): string;
    /**
      * `Import Workspace`
      */
    ["com.affine.workspace.local.import"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.workspaceDelete.button.cancel"](): string;
    /**
      * `Delete`
      */
    ["com.affine.workspaceDelete.button.delete"](): string;
    /**
      * `Please type workspace name to confirm`
      */
    ["com.affine.workspaceDelete.placeholder"](): string;
    /**
      * `Delete Workspace`
      */
    ["com.affine.workspaceDelete.title"](): string;
    /**
      * `Cancel`
      */
    ["com.affine.workspaceLeave.button.cancel"](): string;
    /**
      * `Leave`
      */
    ["com.affine.workspaceLeave.button.leave"](): string;
    /**
      * `After you leave, you will no longer be able to access the contents of this workspace.`
      */
    ["com.affine.workspaceLeave.description"](): string;
    /**
      * `Create Workspace`
      */
    ["com.affine.workspaceList.addWorkspace.create"](): string;
    /**
      * `Create Cloud Workspace`
      */
    ["com.affine.workspaceList.addWorkspace.create-cloud"](): string;
    /**
      * `Cloud Sync`
      */
    ["com.affine.workspaceList.workspaceListType.cloud"](): string;
    /**
      * `Local Storage`
      */
    ["com.affine.workspaceList.workspaceListType.local"](): string;
    /**
      * `All docs`
      */
    ["com.affine.workspaceSubPath.all"](): string;
    /**
      * `Trash`
      */
    ["com.affine.workspaceSubPath.trash"](): string;
    /**
      * `Deleted docs will appear here.`
      */
    ["com.affine.workspaceSubPath.trash.empty-description"](): string;
    /**
      * `Cloud Workspace`
      */
    ["com.affine.workspaceType.cloud"](): string;
    /**
      * `Joined Workspace`
      */
    ["com.affine.workspaceType.joined"](): string;
    /**
      * `Local Workspace`
      */
    ["com.affine.workspaceType.local"](): string;
    /**
      * `Available Offline`
      */
    ["com.affine.workspaceType.offline"](): string;
    /**
      * `Write with a blank page`
      */
    ["com.affine.write_with_a_blank_page"](): string;
    /**
      * `Yesterday`
      */
    ["com.affine.yesterday"](): string;
    /**
      * `core`
      */
    core(): string;
    /**
      * `Dark`
      */
    dark(): string;
    /**
      * `Click Add to Favourites and the doc will appear here.`
      */
    emptyFavorite(): string;
    /**
      * `Shared docs will appear here.`
      */
    emptySharedPages(): string;
    /**
      * `Click Add to Trash and the doc will appear here.`
      */
    emptyTrash(): string;
    /**
      * `Frameless`
      */
    frameless(): string;
    /**
      * `invited you to join`
      */
    ["invited you to join"](): string;
    /**
      * `is a Cloud Workspace.`
      */
    ["is a Cloud Workspace"](): string;
    /**
      * `is a Local Workspace.`
      */
    ["is a Local Workspace"](): string;
    /**
      * `Light`
      */
    light(): string;
    /**
      * `Login success`
      */
    ["login success"](): string;
    /**
      * `Looks like you are browsing on a mobile device.`
      */
    ["mobile device"](): string;
    /**
      * `We are still working on mobile support and recommend you use a desktop device.`
      */
    ["mobile device description"](): string;
    /**
      * `Others`
      */
    others(): string;
    /**
      * `{{title}} restored`
      */
    restored(options: {
        readonly title: string;
    }): string;
    /**
      * `(This page is still being designed.)`
      */
    ["still designed"](): string;
    /**
      * `System`
      */
    system(): string;
    /**
      * `unnamed`
      */
    unnamed(): string;
    /**
      * `Please upgrade to the latest version of Chrome for the best experience.`
      */
    upgradeBrowser(): string;
    /**
      * `{{title}} will be moved to Trash`
      */
    ["will be moved to Trash"](options: {
        readonly title: string;
    }): string;
    /**
      * `Get Started`
      */
    ["com.affine.ai-onboarding.edgeless.get-started"](): string;
    /**
      * `Upgrade to Unlimited Usage`
      */
    ["com.affine.ai-onboarding.edgeless.purchase"](): string;
    /**
      * `will delete member`
      */
    ["will delete member"](): string;
    /**
      * `Copy Private Link`
      */
    ["com.affine.keyboardShortcuts.copy-private-link"](): string;
    /**
      * `Close`
      */
    ["com.affine.peek-view-controls.close"](): string;
    /**
      * `Open this doc`
      */
    ["com.affine.peek-view-controls.open-doc"](): string;
    /**
      * `Open in new tab`
      */
    ["com.affine.peek-view-controls.open-doc-in-new-tab"](): string;
    /**
      * `Open in split view`
      */
    ["com.affine.peek-view-controls.open-doc-in-split-view"](): string;
} { const { t } = useTranslation(); return useMemo(() => createProxy((key) => t.bind(null, key)), [t]); }
function createComponent(i18nKey: string) {
    return (props) => createElement(Trans, { i18nKey, shouldUnescape: true, ...props });
}
export const TypedTrans: {
    /**
      * `All data will be synchronised and saved to the AFFiNE account <1>{{email}}</1>`
      */
    ["Cloud Workspace Description"]: ComponentType<TypedTransProps<{
        readonly email: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> cannot be undone, please proceed with caution. All contents will be lost.`
      */
    ["Delete Workspace Description"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> will delete both local and cloud data, this operation cannot be undone, please proceed with caution.`
      */
    ["Delete Workspace Description2"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Export Workspace <1>{{workspace}}</1> is coming soon`
      */
    ["Export Workspace"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `The entire Workspace is published on the web and can be edited via <1>Workspace Settings</1>.`
      */
    ["Shared Pages In Public Workspace Description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Go to <a>{{link}}</a> for learn more details about AFFiNE AI.`
      */
    ["com.affine.ai-onboarding.general.5.description"]: ComponentType<TypedTransProps<{
        readonly link: string;
    }, {
        a: JSX.Element;
    }>>;
    /**
      * `By continuing, you are agreeing to our <a>AI Terms</a>.`
      */
    ["com.affine.ai-onboarding.general.privacy"]: ComponentType<TypedTransProps<Readonly<{}>, {
        a: JSX.Element;
    }>>;
    /**
      * `Opening <1>AFFiNE</1> app now`
      */
    ["com.affine.auth.open.affine.prompt"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Or <1>sign in with password</1> instead.`
      */
    ["com.affine.auth.sign.auth.code.message.password"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `By clicking “Continue with Google/Email” above, you acknowledge that you agree to AFFiNE's <1>Terms of Conditions</1> and <3>Privacy Policy</3>.`
      */
    ["com.affine.auth.sign.message"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
    /**
      * `An email with a magic link has been sent to <a>{{email}}</a>.`
      */
    ["com.affine.auth.sign.sent.email.message.sent-tips"]: ComponentType<TypedTransProps<{
        readonly email: string;
    }, {
        a: JSX.Element;
    }>>;
    /**
      * `This demo is limited. <1>Download the AFFiNE Client</1> for the latest features and Performance.`
      */
    ["com.affine.banner.content"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `We are upgrading the AFFiNE Cloud service and it is temporarily unavailable on the client side. If you wish to stay updated on the progress and be notified on availability, you can fill out the <1>AFFiNE Cloud Signup</1>.`
      */
    ["com.affine.cloudTempDisable.description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `<0>Add docs:</0> You can freely select docs and add them to the collection.`
      */
    ["com.affine.collection.addPages.tips"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>Add rules:</0> Rules are based on filtering. After adding rules, docs that meet the requirements will be automatically added to the current collection.`
      */
    ["com.affine.collection.addRules.tips"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> selected`
    
      * - com.affine.collection.toolbar.selected_one: `<0>{{count}}</0> collection selected`
    
      * - com.affine.collection.toolbar.selected_other: `<0>{{count}}</0> collection(s) selected`
      */
    ["com.affine.collection.toolbar.selected"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> collection selected`
      */
    ["com.affine.collection.toolbar.selected_one"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> collection(s) selected`
      */
    ["com.affine.collection.toolbar.selected_other"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> collection(s) selected`
      */
    ["com.affine.collection.toolbar.selected_others"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{tag}}</1> cannot be undone, please proceed with caution.`
      */
    ["com.affine.delete-tags.confirm.description"]: ComponentType<TypedTransProps<{
        readonly tag: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Selected <1>{{selectedCount}}</1>, filtered <3>{{filteredCount}}</3>`
      */
    ["com.affine.editCollection.rules.countTips"]: ComponentType<TypedTransProps<Readonly<{
        selectedCount: string;
        filteredCount: string;
    }>, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
    /**
      * `Showing <1>{{count}}</1> docs.`
      */
    ["com.affine.editCollection.rules.countTips.more"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Showing <1>{{count}}</1> doc.`
      */
    ["com.affine.editCollection.rules.countTips.one"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Showing <1>{{count}}</1> docs.`
      */
    ["com.affine.editCollection.rules.countTips.zero"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Please <1>add rules</1> to save this collection or switch to <3>Docs</3>, use manual selection mode`
      */
    ["com.affine.editCollection.rules.empty.noRules.tips"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
    /**
      * `Docs that meet the rules will be added to the current collection <2>{{highlight}}</2>`
      */
    ["com.affine.editCollection.rules.tips"]: ComponentType<TypedTransProps<{
        readonly highlight: string;
    }, {
        ["2"]: JSX.Element;
    }>>;
    /**
      * `If you are still experiencing this issue, please <1>contact us through the community.</1>`
      */
    ["com.affine.error.contact.description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `With the workspace creator's Free account, every member can access up to <1>7 days<1> of version history.`
      */
    ["com.affine.history.confirm-restore-modal.free-plan-prompt.description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `With the workspace creator's Pro account, every member enjoys the privilege of accessing up to <1>30 days<1> of version history.`
      */
    ["com.affine.history.confirm-restore-modal.pro-plan-prompt.description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> selected`
    
      * - com.affine.page.toolbar.selected_one: `<0>{{count}}</0> doc selected`
    
      * - com.affine.page.toolbar.selected_other: `<0>{{count}}</0> doc(s) selected`
      */
    ["com.affine.page.toolbar.selected"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> doc selected`
      */
    ["com.affine.page.toolbar.selected_one"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> doc(s) selected`
      */
    ["com.affine.page.toolbar.selected_other"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> doc(s) selected`
      */
    ["com.affine.page.toolbar.selected_others"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `You are currently on the <a>Free plan</a>.`
      */
    ["com.affine.payment.billing-setting.ai.free-desc"]: ComponentType<TypedTransProps<Readonly<{}>, {
        a: JSX.Element;
    }>>;
    /**
      * `You are currently on the <1>{{planName}} plan</1>.`
      */
    ["com.affine.payment.billing-setting.current-plan.description"]: ComponentType<TypedTransProps<{
        readonly planName: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `You are currently on the monthly <1>{{planName}} plan</1>.`
      */
    ["com.affine.payment.billing-setting.current-plan.description.monthly"]: ComponentType<TypedTransProps<{
        readonly planName: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `You are currently on the yearly <1>{{planName}} plan</1>.`
      */
    ["com.affine.payment.billing-setting.current-plan.description.yearly"]: ComponentType<TypedTransProps<{
        readonly planName: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `You are currently on the {{currentPlan}} plan. If you have any questions, please contact our <3>customer support</3>.`
      */
    ["com.affine.payment.subtitle-active"]: ComponentType<TypedTransProps<{
        readonly currentPlan: string;
    }, {
        ["3"]: JSX.Element;
    }>>;
    /**
      * `If you have any questions, please contact our <1> customer support</1>.`
      */
    ["com.affine.payment.upgrade-success-page.support"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `No doc titles contain <1>{{search}}</1>`
      */
    ["com.affine.selectPage.empty.tips"]: ComponentType<TypedTransProps<{
        readonly search: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Love our app? <1>Star us on GitHub</1> and <2>create issues</2> for your valuable feedback!`
      */
    ["com.affine.settings.suggestion-2"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
        ["2"]: JSX.Element;
    }>>;
    /**
      * `The "<1>{{ name }}</1>" property will be remove from {{ count }} doc(s). This action cannot be undone.`
      */
    ["com.affine.settings.workspace.properties.delete-property-prompt"]: ComponentType<TypedTransProps<Readonly<{
        name: string;
        count: string;
    }>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> doc`
      */
    ["com.affine.settings.workspace.properties.doc"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> docs`
      */
    ["com.affine.settings.workspace.properties.doc_others"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `Manage workspace <1>{{name}}</1> properties`
      */
    ["com.affine.settings.workspace.properties.header.subtitle"]: ComponentType<TypedTransProps<{
        readonly name: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> selected`
    
      * - com.affine.tag.toolbar.selected_one: `<0>{{count}}</0> tag selected`
    
      * - com.affine.tag.toolbar.selected_other: `<0>{{count}}</0> tag(s) selected`
      */
    ["com.affine.tag.toolbar.selected"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> tag selected`
      */
    ["com.affine.tag.toolbar.selected_one"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> tag(s) selected`
      */
    ["com.affine.tag.toolbar.selected_other"]: ComponentType<TypedTransProps<{
        readonly count: string | number | bigint;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `<0>{{count}}</0> tag(s) selected`
      */
    ["com.affine.tag.toolbar.selected_others"]: ComponentType<TypedTransProps<{
        readonly count: string;
    }, {
        ["0"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> cannot be undone, please proceed with caution. All contents will be lost.`
      */
    ["com.affine.workspaceDelete.description"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> will delete both local and cloud data, this operation cannot be undone, please proceed with caution.`
      */
    ["com.affine.workspaceDelete.description2"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Click on the <1>$t(New Doc)</1> button to create your first doc.`
      */
    emptyAllPages: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Click on the <1>$t(New Doc)</1> button Or press <3>{{shortcut}}</3> to create your first doc.`
      */
    emptyAllPagesClient: ComponentType<TypedTransProps<{
        readonly shortcut: string;
    }, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
    /**
      * ` We recommend the <1>Chrome</1> browser for optimal experience.`
      */
    recommendBrowser: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
} = /*#__PURE__*/ createProxy(createComponent);
